import CallRoundedIcon from '@mui/icons-material/CallRounded';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ClearIcon from '@mui/icons-material/Clear';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import VerifiedIcon from '@mui/icons-material/Verified';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import {
  Alert,
  Avatar,
  AvatarGroup,
  Box,
  Button,
  Container,
  Divider,
  Grid,
  Link,
  Paper,
  Snackbar,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
// import Image from 'next/image';
import { useEffect, useState } from 'react';
import Countdown from 'react-countdown';
import { setInterval } from 'timers';

// import Carousel from 'react-material-ui-carousel';
import ExciseSubMenu from '@/components/nav/ExciseSubMenu';
import Popup2290 from '@/components/ui/2290Popup';
import BlogContentExcise from '@/components/ui/BlogContentExcise';
import Form2290DownloadTemplatePopup from '@/components/ui/Form2290DownloadTemplatePopup';
import Form2290ExcelTemplateContactUs from '@/components/ui/Form2290ExcelTemplateContactUs';
import PopupContactUs from '@/components/ui/Popup2290';
import Hidden from '@/components/ui/TzoHidden';
import VideoPopup from '@/components/VideoPopup';
import AppLayout from '@/layouts/AppLayout';
import { Meta } from '@/layouts/Meta';
import { getLastDateOfTheMonth } from '@/utils/utils';

declare global {
  interface Window {
    Tawk_API: {
      maximize: () => void;
      minimize: () => void;
      toggle: () => void;
      showWidget: () => void;
      hideWidget: () => void;
      popup: () => void;
      onLoad?: () => void;
    };
  }
}

const Form2290 = () => {
  const [isvideoPopupSteps, setvideoPopupSteps] = useState(false);
  const [isPopup2290, setIsPopup2290] = useState(false);
  const [openSnack, setSnackOpen] = useState(false);

  const openPopupSteps = () => {
    setvideoPopupSteps(true);
  };
  const openChat = () => {
    window.Tawk_API?.maximize();
  };

  const handleSnackClose = () => {
    setSnackOpen(false);
  };

  // counting number
  // const [visible, setVisible] = useState(false);

  // const { ref, inView } = useInView({
  //   threshold: 0.2,
  //   triggerOnce: false, // change to true if you only want to animate once
  // });
  const [isForm2290Template, setIsForm2290Template] = useState(false);
  const [isForm2290ExcelTemplate, setIsForm2290ExcelTemplate] = useState(false);

  // useEffect(() => {
  //   setVisible(inView);
  // }, [inView]);

  const end = 339258;

  const [value, setValue] = useState(0);

  useEffect(() => {
    const duration = 4000; // 4 seconds
    const startValue = 1;

    let startTime: number | null = null;

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;

      const progress = Math.min((timestamp - startTime) / duration, 1);

      const eased = 1 - Math.pow(1 - progress, 3);

      const current = Math.floor(startValue + (end - startValue) * eased);

      setValue(current);

      if (progress < 1) {
        requestAnimationFrame(animate);
      }
    };

    requestAnimationFrame(animate);
  }, []);

  // const digits = value.toLocaleString('en-US').split('');
  // const digits = value
  //   .toString()
  //   .padStart(end.toString().length, '0')
  //   .split('');

  const staticDigits = end.toString().slice(0, 2).split(''); // ['3', '3']
  const animatedDigits = value
    .toString()
    .padStart(end.toString().length, '0')
    .slice(2)
    .split('');

  // const layoutWrapperContents: LayoutWrapperContents = {
  //   Heading:
  //     '<span style="color:#f48c06;">Attention Truckers!</span> Your 2024 Schedule 1 is expiring soon.',
  //   SubHeading:
  //     'E-file <span style="color:#1da94a;">IRS Form 2290</span> Online Now for Tax Year 2025',
  //   CtaText: 'E-file Now',
  //   CtaSubHeading: ``,
  //   CtaURL: `${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290heavyvehiclesticky`,
  //   isActive: true,
  // };
  const [lastDayTaxSeason, setLastDayTaxSeason] = useState(new Date());

  useEffect(() => {
    setLastDayTaxSeason(getLastDateOfTheMonth(new Date().getFullYear(), 8, 31));
    setInterval(() => {
      setLastDayTaxSeason(
        getLastDateOfTheMonth(new Date().getFullYear(), 8, 31)
      );
    }, 1000);
  }, []);
  // Random component
  const Completionist = () => <span />;

  // Renderer callback with condition
  const renderer = ({
    days,
    hours,
    minutes,
    seconds,
    completed,
  }: {
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
    completed: boolean;
  }) => {
    if (completed) {
      // Render a completed state
      return <Completionist />;
    }
    // Render a countdown
    return (
      <Stack
        direction="row"
        justifyContent={{ xs: 'center', md: 'flex-start' }}
        alignItems="center"
        spacing={1}
        sx={{
          '& .timer-count': {
            border: '1px solid #848484',
            p: 1.5,
            textAlign: 'center',
            minWidth: { xs: 55, sm: 70, md: 70 },
            position: 'relative',
            borderRadius: 2,
            boxShadow: ' 0 0 20px rgba(0,0,0,.12)',
          },
          '& .timer-number': {
            fontSize: { xs: 18, sm: 24 },
            fontWeight: 900,
            color: '#fff',
          },
          '& .colon': {
            fontSize: { xs: 18, sm: 24 },
            px: { xs: 0.2, sm: 0.5 },
            color: '#fff',
            py: 0,
            mt: { xs: '-8px !important', sm: '-14px !important' },
          },
          '& .timer-label': {
            background: '#000',
            borderTop: '1px solid #848484',
            fontSize: { xs: 10, sm: 12 },
            fontWeight: 500,
            mt: 0,
            mx: -1.5,
            mb: -1.5,
            py: 0.2,
            px: { xs: 0.5, sm: 1, lg: 0.5 },
            borderRadius: '0px 0px 8px 8px',
            color: '#d7d7d7',
          },
        }}
      >
        <Box className="timer-count">
          <Box className="timer-number">
            {days?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Day</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {hours?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Hours</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {minutes?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Minutes</Box>
        </Box>
        <Box className="colon">:</Box>
        <Box className="timer-count">
          <Box className="timer-number">
            {seconds?.toString().padStart(2, '0')}
          </Box>
          <Box className="timer-label">Seconds</Box>
        </Box>
      </Stack>
    );
  };

  return (
    <AppLayout
      // LayoutWrapperContents={layoutWrapperContents}
      meta={
        <Meta
          title="IRS Form 2290 Online Filing | Instant HVUT Schedule 1"
          description="E-file IRS Form 2290 online for heavy highway vehicles and get your stamped Schedule 1 in minutes. Fast, secure, and IRS-authorized filing."
          keywords="2290 form ,IRS form 2290, form 2290 online, form 2290 pdf, hvut 2290, hvut payment, proof of hvut payment, Form 2290 Schedule-1"
          canonical="excise-tax/efile-irs-form-2290-heavy-vehicle-use-tax-online/"
          jsonLdPricing="19.99"
          jsonLdAggregateRatingValue="4.97"
          jsonLdAggregateRatingCount="4278"
          ogShareImg="assets/images/excise-share-img.png"
        />
      }
    >
      <Form2290DownloadTemplatePopup
        isForm2290Template={isForm2290Template}
        setIsForm2290Template={setIsForm2290Template}
      />
      <Form2290ExcelTemplateContactUs
        isOpenPopUp={isForm2290ExcelTemplate}
        setIsOpenPopUp={setIsForm2290ExcelTemplate}
      />
      <PopupContactUs
        isForm2290BulkUploadTemplate={isPopup2290}
        setIsForm2290BulkUploadTemplate={setIsPopup2290}
        setSnackOpen={setSnackOpen}
      />
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={openSnack}
        autoHideDuration={6000}
        onClose={handleSnackClose}
        sx={{ top: '150px !important' }}
      >
        <Alert
          onClose={handleSnackClose}
          variant="filled"
          severity="success"
          sx={{
            width: '100%',
            color: '#fff',
            fontWeight: 600,
          }}
        >
          Thank you for contacting TaxZerone.
        </Alert>
      </Snackbar>
      <ExciseSubMenu />
      <VideoPopup
        isvideoPopup={isvideoPopupSteps}
        setvideoPopup={setvideoPopupSteps}
        src="https://www.youtube.com/embed/QnUmGYD2yLw?autoplay=1&rel=0"
      />
      <Popup2290 />
      {/* <ComingSoonPopup open={open} setOpen={setOpen} /> */}
      <Box
        sx={{ mt: 0, py: { xs: 1, sm: 5 }, minHeight: { lg: 585 } }}
        // className="excise-img-bg"
        component="section"
      >
        <Container
          sx={{
            position: 'relative',
            mt: 0,
            mb: 0,
            // maxWidth: { xs: '100%', sm: 820, md: 820, lg: 940 },
          }}
          maxWidth="lg"
        >
          <Box
            sx={{
              background: '#d95623',
              p: 1,
              px: 2,
              color: '#fff',
              '&.ribbon:before': {
                left: { xs: 8, sm: 16 },
                background:
                  'url(/assets/images/ribbon-bg-new.webp) repeat 100%',
                transform: 'rotate(-360deg)',
              },
              '&.ribbon:after': {
                right: { xs: 8, sm: 16 },
                background:
                  'url(/assets/images/ribbon-bg-new.webp) repeat 100%',
                transform: 'rotate(-180deg)',
              },
            }}
            className="ribbon"
          >
            <Stack
              direction={{ xs: 'column', sm: 'row' }}
              alignItems="center"
              spacing={{ xs: 1, sm: 2 }}
              justifyContent="center"
            >
              <Typography
                variant="body1"
                sx={{
                  textAlign: { xs: 'center', sm: 'left' },
                  fontSize: { xs: 16, sm: 18, md: 18, lg: '1.13rem' },
                  color: '#eee',
                }}
              >
                <strong>📢 Deadline Has Passed!</strong> File{' '}
                <b style={{ color: '#fff', fontWeight: 600 }}>
                  Form 2290 (2026–27) Now{' '}
                </b>
                to Avoid Further{' '}
                <b style={{ color: '#fff', fontWeight: 600 }}>Penalties.</b>
              </Typography>
              <Box>
                {/* <Typography
                  variant="body2"
                  sx={{
                    textAlign: 'center',
                    mb: { xs: 1, sm: 1 },
                    lineHeight: 1.3,
                    color: '#ececec',
                  }}
                >
                  Time left to file before the deadline{' '}
                  <Hidden smUp>
                    <br />
                  </Hidden>
                  (
                  <span style={{ fontWeight: 600, color: '#fff' }}>
                    Aug 31, 2026
                  </span>
                  ):
                </Typography> */}
                <Countdown date={lastDayTaxSeason} renderer={renderer} />
              </Box>
              <Box sx={{ textAlign: 'right' }}>
                <Button
                  variant="contained"
                  size="large"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                  sx={{
                    backgroundColor: '#fff',
                    '&:hover, &:focus': {
                      backgroundColor: '#333',
                      color: '#fff',
                      boxShadow: 'none',
                    },
                    px: 2,
                    color: '#333',
                    mt: { xs: 0, md: 0 },
                    display: { xs: 'inline-block', sm: 'inline-block' },
                    mx: { xs: 'auto', sm: 1 },
                    borderRadius: 3,
                    boxShadow: 'none',
                    fontSize: 18,
                    textTransform: 'none',
                    whiteSpace: 'nowrap',
                  }}
                >
                  E-File Now
                </Button>
              </Box>
            </Stack>
          </Box>
        </Container>
        <Container maxWidth="xl">
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={3}
            sx={{ px: { xs: 2, md: 0 } }}
          >
            <Box
              sx={{
                textAlign: { xs: 'center', md: 'left' },
                alignItems: 'center',
                display: 'flex',
                width: '100%',
                maxWidth: { xs: 'inherit', lg: 770 },
                minWidth: { xs: 'inherit', md: 530 },
                pl: { xs: 0, md: 6, lg: 8, xl: 12 },
                justifyContent: 'center',
              }}
            >
              <Box
                component="header"
                sx={{
                  mt: { xs: 2, sm: 4, md: 5 },
                  mb: { xs: 2, sm: 4, md: 5 },
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    // color: '#fff',
                    fontSize: { md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    mb: 1,
                  }}
                >
                  Trusted by{' '}
                  <span style={{ fontWeight: 600, color: '#000000' }}>
                    {' '}
                    100,000+
                  </span>{' '}
                  Truckers & Fleet owners Nationwide
                </Typography>

                <Typography
                  variant="h1"
                  sx={{
                    fontSize: { lg: 40, md: 30, sm: 24, xs: 24 },
                    fontWeight: 600,
                    // color: '#fff',
                    mb: 3,
                  }}
                >
                  E-File IRS Form 2290 Online for{' '}
                  <span className="highlight-container">
                    <span className="highlight">Tax Year 2026–27 </span>
                  </span>{' '}
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    lineHeight: 1.5,
                    mb: 4,
                    // color: '#d0d0d0',
                  }}
                >
                  Get your HVUT return filed and receive your{' '}
                  <b style={{ color: '#000000' }}>
                    IRS-stamped Schedule 1 in minutes{' '}
                  </b>{' '}
                  with TaxZerone's trusted service.
                </Typography>
                <Stack
                  direction={{ xs: 'column-reverse', md: 'row' }}
                  spacing={{ xs: 1, md: 2 }}
                  justifyContent={{
                    xs: 'center',
                    md: 'left',
                  }}
                  alignItems={{
                    xs: 'center',
                    md: 'flex-start',
                  }}
                  sx={{ mt: 3 }}
                >
                  <Box
                    sx={{
                      textAlign: { xs: 'center', md: 'left' },
                      mr: { xs: 0, md: 0 },
                    }}
                  >
                    <Button
                      variant="contained"
                      className="btn-primary medium"
                      sx={{
                        '&.btn-primary.medium': {
                          fontSize: {
                            xs: '15px !important',
                            sm: '20px  !important',
                            md: '17px !important',
                            lg: '20px !important',
                          },
                        },
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                      href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                    >
                      Start Filing for Free
                    </Button>
                    <Typography
                      variant="body2"
                      sx={{
                        mt: 1,
                        fontSize: { xs: 11, sm: 14 },
                        color: '#2e2e2e',
                      }}
                    >
                      No credit card required. Pay only when you file.
                    </Typography>
                  </Box>

                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent={{
                      xs: 'center',
                      md: 'flex-start',
                    }}
                    alignItems="center"
                  >
                    <Box
                      sx={{
                        mt: { xs: '0 !important', md: '-16px !important' },
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/irs-authorized.webp" />
                        <source srcSet="/assets/images/irs-authorized.png" />
                        <Box
                          component="img"
                          src="/assets/images/irs-authorized.png"
                          loading="lazy"
                          alt="IRS-authorized e-file provider"
                          width={70}
                          height={69}
                          sx={{
                            width: { xs: 50, md: 70 },
                            height: { xs: 49, md: 69 },
                          }}
                        />
                      </picture>
                    </Box>
                    <Box
                      sx={{
                        mt: { xs: '0px !important', md: '-16px !important' },
                      }}
                    >
                      <picture>
                        <source srcSet="/assets/images/tzo-soc2.webp" />
                        <source srcSet="/assets/images/tzo-soc2.png" />
                        <Box
                          component="img"
                          src="/assets/images/tzo-soc2.png"
                          loading="lazy"
                          alt="TZO SOC2 Compliant"
                          width={90}
                          height={89}
                          sx={{
                            width: { xs: 70, md: 90 },
                            height: { xs: 69, md: 89 },
                          }}
                        />
                      </picture>
                    </Box>
                  </Stack>
                </Stack>
                <Link
                  href="/user-testimonials/"
                  sx={{ textDecoration: 'none' }}
                >
                  <Stack
                    spacing={2}
                    direction="row"
                    sx={{
                      mt: 3,
                      textAlign: 'left',
                      alignSelf: 'left',
                      justifyContent: { md: 'left', sm: 'center' },
                      // ml: { md: -3.5, sm: 3, xs: 0 },
                    }}
                  >
                    <AvatarGroup
                      spacing={18}
                      sx={{
                        // border: 'none !important',

                        '& .MuiAvatar-root': {
                          border: 'none',
                        },
                        '& :where(.avatar1, .avatar2, .avatar3)': {
                          height: 42,
                          width: 42,
                          borderRadius: '50%',
                          border: 'none',
                          p: 0.1,
                          fontSize: '14px !important',
                          fontWeight: 600,
                          color: '#333 !important',
                        },
                        '& .avatar1': {
                          backgroundColor: '#AEE2FF',
                        },

                        '& .avatar2': {
                          backgroundColor: '#DFF1F1',
                        },

                        '& .avatar3': {
                          backgroundColor: '#C9BEFF',
                        },
                      }}
                    >
                      <Avatar className="avatar1">MC</Avatar>
                      <Avatar className="avatar2">BC</Avatar>
                      <Avatar className="avatar3">JP</Avatar>
                    </AvatarGroup>

                    <Stack
                      direction="column"
                      spacing={0.1}
                      sx={{ mt: 1 }}
                      justifyContent={{ xs: 'center', md: 'center' }}
                    >
                      <Box>
                        <img
                          src="/assets/images/star-icon.svg"
                          width={18}
                          height={17}
                          alt="star-1"
                        />
                        <img
                          src="/assets/images/star-icon.svg"
                          width={18}
                          height={17}
                          alt="star-2"
                        />
                        <img
                          src="/assets/images/star-icon.svg"
                          width={18}
                          height={17}
                          alt="star-3"
                        />
                        <img
                          src="/assets/images/star-icon.svg"
                          width={18}
                          height={17}
                          alt="star-4"
                        />
                        <img
                          src="/assets/images/star-icon.svg"
                          width={18}
                          height={17}
                          alt="star-5"
                        />
                      </Box>
                      <Typography
                        variant="body2"
                        sx={{ color: '#2e2e2e', fontWeight: 500 }}
                      >
                        4.9/5 from 3200+ verified business reviews
                      </Typography>
                    </Stack>
                  </Stack>
                </Link>
              </Box>
            </Box>

            <Box
              itemScope
              itemType="https://schema.org/ImageObject"
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
                width: '100%',
              }}
            >
              {/* Metadata not visible on screen */}
              <meta
                itemProp="name"
                content="E-File IRS Form 2290 Online for Tax Year 2026–27"
              />
              <link
                itemProp="contentUrl"
                href="https://www.taxzerone.com/assets/images/f2290-landing-img.png"
              />

              <picture style={{ marginBottom: -7 }}>
                <source
                  srcSet="/assets/images/f2290-landing-img.webp"
                  type="image/webp"
                  width={880}
                  height={725}
                />

                <source
                  srcSet="/assets/images/f2290-landing-img.png"
                  type="image/png"
                  width={880}
                  height={725}
                />

                {/* Visible image carrying the schema properties */}
                <img
                  itemProp="url"
                  src="/assets/images/f2290-landing-img.png"
                  alt="E-File IRS Form 2290 Online for Tax Year 2026–27"
                  className="img-responsive-banner"
                  width={880}
                  height={725}
                />
              </picture>
            </Box>
          </Stack>
        </Container>
        <Container maxWidth="xl" sx={{}}>
          <Box
            component="div"
            sx={{
              mt: { xs: 2, sm: 4, md: 10 },
              mb: { xs: 2, sm: 4, md: 5 },
              position: 'relative',
              textAlign: 'left',
            }}
          />
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: 1, py: 1 }}>
          <Box sx={{ py: { md: 6, xs: 4 }, borderBottom: '1px solid #ccc' }}>
            <Paper
              elevation={0}
              sx={{
                position: 'relative',
                overflow: 'hidden',
                borderRadius: 5,
                mb: 0,
                background: '#fff',
                border: '1px solid #E5E7EB',

                transition: '0.35s',
                display: 'flex',
                alignItems: 'stretch',
                minHeight: { xs: 'auto', md: 320, lg: 360, xl: 400 }, // ✅ gives image room to render
              }}
            >
              <Box
                sx={{
                  flex: 1,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  p: { xs: 3, md: 4 },
                  pr: { md: 26, lg: 32, xl: 40 },
                }}
              >
                <Typography
                  sx={{
                    color: '#16a34a',
                    fontWeight: 500,
                    fontSize: 14,
                    textTransform: 'uppercase',
                    letterSpacing: 2,
                    mb: 1,
                  }}
                >
                  Full-Service Filing
                </Typography>

                <Typography
                  variant="h2"
                  sx={{
                    fontWeight: 600,
                    fontSize: { xs: 25, sm: 30, md: 33, lg: 33 },
                    mb: 2,
                  }}
                >
                  Call to File
                </Typography>

                <Typography
                  sx={{
                    // lineHeight: 1.8,
                    maxWidth: 650,
                    mb: 2,
                  }}
                >
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    Don't have time to file?
                  </strong>{' '}
                  Simply call our support team and share your business and
                  vehicle details.
                </Typography>
                <Typography
                  sx={{
                    // lineHeight: 1.8,
                    maxWidth: 650,
                    mb: 2,
                  }}
                >
                  We&apos;ll prepare and e-file your Form 2290 on your behalf,
                  so you can receive your{' '}
                  <strong style={{ fontWeight: 600 }}>
                    {' '}
                    IRS-stamped Schedule 1
                  </strong>{' '}
                  as soon as your return is accepted.
                </Typography>

                <Paper
                  elevation={0}
                  onClick={() => window.open('tel:+14084447120', '_self')}
                  sx={{
                    position: 'relative',
                    width: 280,
                    height: 60,
                    borderRadius: '24px',
                    // border: '2px solid #16a34a',
                    bgcolor: '#213e99',
                    overflow: 'hidden',
                    cursor: 'pointer',

                    // '&:hover .call-text': {
                    //   opacity: 0,
                    //   transform: 'translateX(40px)',
                    // },

                    // '&:hover .call-icon': {
                    //   left: '50%',
                    //   transform: 'translate(-50%, -50%)',
                    // },
                  }}
                >
                  {/* Icon */}
                  <Box
                    className="call-icon"
                    sx={{
                      position: 'absolute',
                      left: 16,
                      top: '50%',
                      transform: 'translateY(-50%)',
                      width: 56,
                      height: 56,
                      borderRadius: '50%',
                      bgcolor: 'transparent',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#ffffff',
                      transition: 'all .5s cubic-bezier(.4,0,.2,1)',
                      zIndex: 2,

                      '&::before': {
                        content: '""',
                        position: 'absolute',
                        inset: 0,
                        borderRadius: '50%',
                        border: '2px solid #ffff',
                        zIndex: -1,
                        animation: 'pulse 3s infinite',
                      },

                      '@keyframes pulse': {
                        '0%': { transform: 'scale(0.5)', opacity: 0.5 },
                        '70%': { transform: 'scale(1.2)', opacity: 0 },
                        '100%': { transform: 'scale(1.6)', opacity: 0 },
                      },
                    }}
                  >
                    <CallRoundedIcon />
                  </Box>

                  {/* Text */}
                  <Box
                    className="call-text"
                    sx={{
                      ml: 10,
                      height: '100%',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      transition: 'all .5s cubic-bezier(.4,0,.2,1)',
                    }}
                  >
                    <Typography sx={{ fontSize: 12, color: '#d5d5d5' }}>
                      Call Now
                    </Typography>

                    <Typography
                      sx={{
                        fontWeight: 600,
                        fontSize: 20,
                        color: '#ffffff',
                      }}
                    >
                      (408) 444-7120
                    </Typography>
                  </Box>
                </Paper>
              </Box>
              {/* Floating Phone */}
              <Box
                sx={{
                  position: 'absolute',
                  right: { md: 20, lg: 35 },
                  bottom: 0,
                  display: { xs: 'none', md: 'block' },
                  width: { md: 350, lg: 450, xl: 450 },
                  height: 'auto',
                  pointerEvents: 'none',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/call-file-form-2290-img.webp"
                    type="image/webp"
                  />
                  <Box
                    component="img"
                    src="/assets/images/call-file-form-2290-img.png"
                    alt="Who Qualifies for a Suspended Vehicle Exemption?"
                    sx={{
                      width: '100%',
                      height: 'auto',
                      display: 'block',
                    }}
                  />
                </picture>
              </Box>
            </Paper>
          </Box>
          <Grid container spacing={2} sx={{ mt: 3, mb: 4 }}>
            <Grid size={{ md: 12, sm: 12, xs: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 2,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Other Convenient Ways to File
              </Typography>
            </Grid>

            <Grid size={{ md: 6, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 4.5,
                  borderRadius: 5,
                  minHeight: '100%',
                  textAlign: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/email-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/email-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/email-icon.png"
                      alt="Email Your Template"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 22, sm: 18, xs: 16 },
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Email Your Template
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Complete our free Excel template and email it to our team.
                  We'll review, prepare, and e-file your return for you.
                </Typography>
                <Stack
                  spacing={2}
                  direction="row"
                  sx={{ justifyContent: 'center', mt: 3 }}
                >
                  <Box
                    sx={{
                      mt: 3,
                    }}
                  >
                    <Button
                      size="large"
                      variant="contained"
                      sx={{
                        borderRadius: 4,
                        textTransform: 'none',
                        boxShadow: 'none',
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                      onClick={() => setIsForm2290Template(true)}
                    >
                      <FileDownloadOutlinedIcon sx={{ mr: 0.8 }} /> Download
                      Template
                    </Button>
                  </Box>
                  <Box
                    sx={{
                      mt: 3,
                    }}
                  >
                    <Button
                      size="large"
                      variant="contained"
                      sx={{
                        borderRadius: 4,
                        backgroundColor: '#16a34a',
                        textTransform: 'none',
                        boxShadow: 'none',
                        transition: 'all 0.3s ease 0s',
                        '&:hover, &:focus, &:active': {
                          transform: 'scale(1.1)',
                        },
                      }}
                      onClick={() => setIsForm2290ExcelTemplate(true)}
                    >
                      <FileUploadOutlinedIcon sx={{ mr: 0.8 }} /> Upload Your
                      Template
                    </Button>
                  </Box>
                </Stack>
                <Typography variant="body2" sx={{ mt: 1 }}>
                  {' '}
                  Available 24/7
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 6, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 5,
                  borderRadius: 5,
                  minHeight: '100%',
                  textAlign: 'center',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/chat-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/chat-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/chat-icon.png"
                      alt="Chat & File"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 22, sm: 18, xs: 16 },
                    mb: 1,
                    mt: 2,
                  }}
                >
                  Chat & File
                </Typography>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  Start a live chat with our experts, share your details, and
                  let us handle your filing from start to finish.
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    onClick={openChat}
                  >
                    Start Live Chat
                  </Button>
                  <Typography variant="body2" sx={{ mt: 1 }}>
                    {' '}
                    Mon – Fri (9 AM to 5 PM CST)
                  </Typography>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Container maxWidth="lg" sx={{ my: 5 }} component="section">
        <Grid container spacing={2}>
          <Grid
            size={{ md: 12, sm: 12, xs: 12 }}
            sx={{
              justifyContent: 'center',
              alignItems: 'center',
              textAlign: 'center',
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 3,
                textAlign: 'center',
                lineHeight: 1.5,
              }}
            >
              Number of Vehicles Filed and Still Counting
            </Typography>
            <Box>
              <Box
                component="img"
                src="/assets/images/trucker-img.webp"
                alt="Number of Vehicles Filed and Still Counting"
                className="img-responsive"
                loading="lazy"
                width={540}
                height={250}
                sx={{}}
              />
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: 1,
                }}
              >
                {staticDigits.map((digit, index) => (
                  <Box
                    key={`static-${index}`}
                    sx={{
                      width: 85,
                      height: 85,
                      borderRadius: 2,
                      background: '#050b30',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: '#fff',
                      fontSize: 50,
                      fontWeight: 700,
                    }}
                  >
                    {digit}
                  </Box>
                ))}
                {animatedDigits.map((char, index) => (
                  <Box
                    key={`animated-${index}`}
                    sx={{
                      width: 85,
                      height: 85,
                      overflow: 'hidden',
                      borderRadius: 2,
                      background: '#050b30',
                    }}
                  >
                    <Box
                      sx={{
                        transform: `translateY(-${Number(char) * 85}px)`,
                        transition: 'transform .3s ease-out',
                      }}
                    >
                      {Array.from({ length: 90 }, (_, i) => (
                        <Box
                          key={i}
                          sx={{
                            width: 85,
                            height: 85,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: 50,
                            fontWeight: 700,
                          }}
                        >
                          {i}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))}

                {/* {digits.map((char, index) => (
                  <Box
                    key={index}
                    sx={{
                      width: 85,
                      height: 85,
                      overflow: 'hidden',
                      borderRadius: 2,
                      background: '#050b30',
                    }}
                  >
                    <Box
                      sx={{
                        transform: `translateY(-${Number(char) * 85}px)`,
                        transition: 'transform .3s ease-out',
                      }}
                    >
                      {Array.from({ length: 10 }, (_, i) => (
                        <Box
                          key={i}
                          sx={{
                            width: 85,
                            height: 85,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: 50,
                            fontWeight: 700,
                          }}
                        >
                          {i}
                        </Box>
                      ))}
                    </Box>
                  </Box>
                ))} */}
              </Box>
              {/* <Stack
                spacing={1}
                direction="row"
                sx={{ justifyContent: 'center', mb: 2 }}
              >
                <Box
                  component="div"
                  ref={ref}
                  sx={{
                    background:
                      'linear-gradient(180deg,rgba(2, 1, 36, 1) 53%, rgba(3, 18, 46, 1) 53%)',
                    boxShadow: 'rgba(100, 100, 111, 0.54) 0px 7px 29px 0px',
                    borderRadius: 2,
                    width: '72px !important',
                    height: '72px',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    m: 'auto',
                    display: 'flex',
                    p: 0.2,
                  }}
                >
                  {visible ? (
                    <CountUp
                      end={3}
                      duration={10}
                      suffix=""
                      style={{
                        fontWeight: 600,
                        fontSize: 53,
                        color: '#fff',
                      }}
                    />
                  ) : (
                    'count'
                  )}
                </Box>
                <Box
                  component="div"
                  ref={ref}
                  sx={{
                    background:
                      'linear-gradient(180deg,rgba(2, 1, 36, 1) 53%, rgba(3, 18, 46, 1) 53%)',
                    boxShadow: 'rgba(100, 100, 111, 0.54) 0px 7px 29px 0px',
                    borderRadius: 2,
                    width: '72px !important',
                    height: '72px',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    m: 'auto',
                    display: 'flex',
                    p: 0.2,
                  }}
                >
                  {visible ? (
                    <CountUp
                      end={3}
                      duration={10}
                      suffix=""
                      style={{
                        fontWeight: 600,
                        fontSize: 53,
                        color: '#fff',
                      }}
                    />
                  ) : (
                    'count'
                  )}
                </Box>
                <Box
                  component="div"
                  ref={ref}
                  sx={{
                    background:
                      'linear-gradient(180deg,rgba(2, 1, 36, 1) 53%, rgba(3, 18, 46, 1) 53%)',
                    boxShadow: 'rgba(100, 100, 111, 0.54) 0px 7px 29px 0px',
                    borderRadius: 2,
                    width: '72px !important',
                    height: '72px',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    m: 'auto',
                    display: 'flex',
                    p: 0.2,
                  }}
                >
                  {visible ? (
                    <CountUp
                      end={9}
                      duration={10}
                      suffix=""
                      style={{
                        fontWeight: 600,
                        fontSize: 53,
                        color: '#fff',
                      }}
                    />
                  ) : (
                    'count'
                  )}
                </Box>
                <Box
                  component="div"
                  ref={ref}
                  sx={{
                    background:
                      'linear-gradient(180deg,rgba(2, 1, 36, 1) 53%, rgba(3, 18, 46, 1) 53%)',
                    boxShadow: 'rgba(100, 100, 111, 0.54) 0px 7px 29px 0px',
                    borderRadius: 2,
                    width: '72px !important',
                    height: '72px',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    m: 'auto',
                    display: 'flex',
                    p: 0.2,
                  }}
                >
                  {visible ? (
                    <CountUp
                      end={2}
                      duration={15}
                      suffix=""
                      style={{
                        fontWeight: 600,
                        fontSize: 53,
                        color: '#fff',
                      }}
                    />
                  ) : (
                    'count'
                  )}
                </Box>
                <Box
                  component="div"
                  ref={ref}
                  sx={{
                    background:
                      'linear-gradient(180deg,rgba(2, 1, 36, 1) 53%, rgba(3, 18, 46, 1) 53%)',
                    boxShadow: 'rgba(100, 100, 111, 0.54) 0px 7px 29px 0px',
                    borderRadius: 2,
                    width: '72px !important',
                    height: '72px',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    m: 'auto',
                    display: 'flex',
                    p: 0.2,
                  }}
                >
                  {visible ? (
                    <CountUp
                      end={5}
                      duration={20}
                      suffix=""
                      style={{
                        fontWeight: 600,
                        fontSize: 53,
                        color: '#fff',
                      }}
                    />
                  ) : (
                    'count'
                  )}
                </Box>
                <Box
                  component="div"
                  ref={ref}
                  sx={{
                    background:
                      'linear-gradient(180deg,rgba(2, 1, 36, 1) 53%, rgba(3, 18, 46, 1) 53%);',
                    boxShadow: 'rgba(100, 100, 111, 0.54) 0px 7px 29px 0px',
                    borderRadius: 2,
                    width: '72px !important',
                    height: '72px',
                    textAlign: 'center',
                    alignItems: 'center',
                    justifyContent: 'center',
                    m: 'auto',
                    display: 'flex',
                    p: 0.2,
                  }}
                >
                  {visible ? (
                    <CountUp
                      end={8}
                      duration={25}
                      suffix=""
                      style={{
                        fontWeight: 600,
                        fontSize: 53,
                        color: '#fff',
                      }}
                    />
                  ) : (
                    'count'
                  )}
                </Box>
              </Stack> */}
              <Typography variant="body1" sx={{ mt: 2 }}>
                TaxZerone has successfully processed these vehicles, helping
                trucking businesses of all sizes.
              </Typography>
              <Box
                sx={{
                  mt: 3,
                  mb: 4,
                  display: 'flex',
                  gap: 3,
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Button
                  variant="contained"
                  className="btn-primary medium"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                  sx={{
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                >
                  E-File Now!
                </Button>
                <Typography variant="body1">
                  {' '}
                  <Link href="#works" sx={{ color: '#0202ff' }}>
                    {' '}
                    How it Works?
                  </Link>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Container>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={5}
            py={{ xs: 0, sm: 4, md: 5 }}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid size={{ xs: 12, sm: 12, md: 12 }}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                }}
              >
                Why File Form 2290 Online with TaxZerone?
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Get Schedule 1 in Minutes"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Get Schedule 1
                  <br />
                  in Minutes
                </Typography>
                <Typography variant="body1">
                  E-file Form 2290 now to pay HVUT and get your{' '}
                  <b>IRS-stamped Schedule 1</b> within minutes.
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                  >
                    E-File Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/vin-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/vin-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/vin-icon.png"
                      alt="FREE VIN Correction (Amendment)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  FREE VIN Correction (Amendment)
                </Typography>
                <Typography variant="body1">
                  Did you enter the wrong VIN on your HVUT form? No problem!
                  Correct it for <b>FREE with TaxZerone</b>.
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                  >
                    Amendment Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/free-efile-retransmission-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/free-efile-retransmission-icon.png"
                      alt="FREE Retransmission of rejected returns"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  FREE Retransmission of rejected returns
                </Typography>
                <Typography variant="body1">
                  If the IRS rejects your return for any reason, you can correct
                  and <b>resend it at no extra cost</b>.
                </Typography>
                <Box
                  sx={{
                    mt: 3,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                  >
                    E-file Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
        }}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
            sx={{ flexDirection: { xs: 'column', md: 'row' } }}
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What is Form 2290?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  IRS Form 2290 is used to report and pay the Heavy Vehicle Use
                  Tax (HVUT) for vehicles that weigh 55,000 pounds or more and
                  operate on public highways in the U.S. This federal tax helps
                  fund highway maintenance and infrastructure.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  If you own a qualifying truck, you must file road tax annually
                  and receive a stamped Schedule 1 from the IRS. This Schedule 1
                  is required for vehicle registration, renewal, and compliance
                  during roadside checks. Whether you’re an individual
                  owner-operator or managing a fleet, timely and accurate filing
                  ensures your trucks stay legally operational.
                </Typography>

                <Box
                  sx={{
                    width: 'auto',
                    textAlign: 'left',
                    alignItems: 'center',
                    display: 'inline-block',
                    mt: { xs: 2, sm: 2 },
                  }}
                >
                  <Button
                    variant="contained"
                    className="btn-primary medium"
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                    sx={{
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                  >
                    File Your Form 2290 Online Now!
                  </Button>
                  <Typography
                    variant="body2"
                    sx={{ mt: 1, mb: 0, textAlign: 'center' }}
                    id="auto-magic-2290"
                  >
                    Simplify Your HVUT Filing with TaxZerone!
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                itemScope
                itemType="https://schema.org/VideoObject"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                  width: '100%',
                }}
              >
                <meta
                  itemProp="name"
                  content="What is Form 2290: A Comprehensive Guide"
                />

                <meta
                  itemProp="description"
                  content="A comprehensive guide explaining IRS Form 2290, the Heavy Vehicle Use Tax (HVUT), and how to file it online with TaxZerone."
                />

                <meta
                  itemProp="thumbnailUrl"
                  content="https://img.youtube.com/vi/-qmF_P841Sc/maxresdefault.jpg"
                />

                <meta
                  itemProp="uploadDate"
                  content="2026-04-03T00:00:00+00:00"
                />

                <Box
                  component="iframe"
                  title="What is Form 2290: A Comprehensive Guide"
                  itemProp="embedUrl"
                  src="https://www.youtube.com/embed/-qmF_P841Sc"
                  sx={{
                    width: { xs: '100%', sm: 580 },
                    height: { xs: '100%', sm: 321 },
                    border: '10px solid #333 !important',
                    borderRadius: 5,
                  }}
                  allowFullScreen
                />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={6}
            mb={9}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid
              size={{ xs: 12, md: 12 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Who is required to file the heavy highway vehicle
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>{' '}
                  use tax return?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  You are required to file the HVUT Form, if a taxable highway
                  motor vehicle is registered{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>{' '}
                  in your name and has a taxable gross weight of{' '}
                  <span style={{ fontWeight: 600 }}>
                    {' '}
                    55,000 pounds or more
                  </span>{' '}
                  and is{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>{' '}
                  used on public highways. This includes:
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/ower-operator-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/ower-operator-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/ower-operator-icon.png"
                      alt="Owner-Operators"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Owner-Operators
                </Typography>
                <Typography variant="body1">
                  Individual truck owners driving commerically
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fleet-owner-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fleet-owner-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fleet-owner-icon.png"
                      alt="Trucking Companies or Fleet Owners"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Trucking Companies or Fleet Owners
                </Typography>
                <Typography variant="body1">
                  Fleet Owners with multiple vehicles
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/agricultural-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/agricultural-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/agricultural-icon.png"
                      alt="Agricultural Businesses"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Agricultural Businesses
                </Typography>
                <Typography variant="body1">
                  Farm vehicles over 55,000 lbs (7,500-mile threshold)
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/logging-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/logging-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/logging-icon.png"
                      alt="Logging Industry Vehicles"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Logging Industry Vehicles
                </Typography>
                <Typography variant="body1">
                  Commercial logging vehicles on public roads
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/lease-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/lease-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/lease-icon.png"
                      alt="Leasing Companies"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Leasing Companies
                </Typography>
                <Typography variant="body1">
                  Companies leasing heavy highway vehicles
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/exempt-organs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/exempt-organs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/exempt-organs-icon.png"
                      alt="Government or Exempt Organizations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Government or Exempt Organizations
                </Typography>
                <Typography variant="body1">
                  Must file even if exempt form payment
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#efefef',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/mileage-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/mileage-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/mileage-icon.png"
                      alt="Suspended Vehicles (Limited Mileage)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Suspended Vehicles (Limited Mileage)
                </Typography>
                <Typography variant="body1">
                  Low-mileage vehicles - file to claim exemption
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: { lg: 6, md: 6, sm: 5, xs: 4 },
          textAlign: 'center',
        }}
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 4 }}>
          <Typography
            variant="h2"
            //  color="white"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 2,
              mt: 4,
            }}
          >
            Due Date to file IRS 2290 Form for the 2026 Tax Year
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: { lg: 20, md: 20, sm: 18, xs: 18 },
              fontWeight: 400,
              //  color: '#f3f3f3',
              mb: 3,
            }}
          >
            The due date for filing HVUT depends on when the vehicle{' '}
            <Hidden smDown>
              {' '}
              <br />
            </Hidden>{' '}
            is first used on a public highway.
          </Typography>
          <Grid container spacing={2}>
            <Grid size={{ md: 6, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  py: 5,
                  minHeight: '100%',
                  borderRadius: 3,
                  backgroundColor: '#e3f2fd',
                }}
              >
                <Stack
                  spacing={2}
                  direction={{ md: 'row', xs: 'column' }}
                  sx={{ justifyContent: 'center', mb: 5 }}
                >
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      px: 4,
                      borderRadius: 3,
                      minHeight: '100%',
                      backgroundColor: '#eaffeb',
                      borderBottom: '3px solid #0f6f2f',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 500,
                        mb: 0.5,
                        fontSize: { md: 18, sm: 16, xs: 15 },
                      }}
                    >
                      First Used Month
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { md: 34, sm: 20, xs: 18 },
                        fontWeight: 600,
                      }}
                    >
                      July
                    </Typography>
                  </Paper>
                  <Paper
                    variant="outlined"
                    sx={{
                      p: 3,
                      borderRadius: 3,
                      minHeight: '100%',
                      backgroundColor: 'rgb(255, 221, 224)',
                      borderBottom: '3px solid #e60000',
                    }}
                  >
                    <Typography
                      variant="h3"
                      sx={{
                        fontWeight: 500,
                        mb: 0.5,
                        fontSize: { md: 18, sm: 16, xs: 15 },
                      }}
                    >
                      Due Date
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        fontSize: { md: 34, sm: 20, xs: 18 },
                        fontWeight: 600,
                      }}
                    >
                      August 31*
                    </Typography>
                  </Paper>
                </Stack>
                <Alert
                  icon={false}
                  severity="warning"
                  sx={{
                    mt: 0,
                    mb: 2,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                    m: 'atuo',
                    maxWidth: 600,
                    display: 'flex',
                    textAlign: 'left',
                  }}
                >
                  <b> Note:</b> * If the deadline falls on a weekend or federal
                  holiday, the next business day will be considered.
                </Alert>
              </Paper>
            </Grid>
            <Grid size={{ md: 6, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  py: 5,
                  minHeight: '100%',
                  borderRadius: 3,
                  backgroundColor: '#dbe7e4',
                }}
              >
                <Typography
                  variant="body1"
                  component="div"
                  sx={{ mb: 6, p: 2, textAlign: 'left', display: 'flex' }}
                >
                  <InfoOutlinedIcon sx={{ mr: 1 }} />
                  <Box>
                    {' '}
                    If your truck is first used later in the year, your due date
                    becomes the last day of the month following the first used
                    month (FUM).
                  </Box>
                </Typography>
                <Box sx={{ mx: 0, display: 'flex', justifyContent: 'center' }}>
                  <Alert
                    icon={false}
                    severity="warning"
                    sx={{
                      mt: 0,
                      mb: 3,
                      borderLeft: '3px solid rgb(102, 60, 0)',
                      m: 'atuo',
                      maxWidth: 600,
                      display: 'flex',
                      textAlign: 'left',
                    }}
                  >
                    <b> Note:</b> Refer to the{' '}
                    <Link
                      href="/resources/excise-tax/form-2290-due-dates/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 2290 due date
                    </Link>{' '}
                    page for your vehicle’s first used month.
                  </Alert>
                </Box>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
          flexDirection: 'column',
        }}
        spacing={2}
        m={0}
        itemScope
        itemType="https://schema.org/HowTo"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            sx={{ mt: { xs: 2, sm: 6, md: 8 } }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              {/* Directly mapped visible title for Google and AI */}
              <Typography
                variant="h2"
                itemProp="name"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                  lineHeight: 1.5,
                  scrollMarginTop: 120,
                }}
                id="works"
              >
                How to File IRS Form 2290 Online in 3 Easy Steps
              </Typography>
              <Typography
                variant="body1"
                itemProp="description"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                TaxZerone makes filing your heavy highway tax return fast,
                simple, and secure—so you can get back on the road.
              </Typography>
            </Grid>
          </Grid>
        </Container>
        <Container maxWidth="xl" sx={{ mb: 5 }}>
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={{ xs: 2, md: 5 }}
          >
            <Box
              component="div"
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                mt: { xs: -3, md: -5, lg: -8 },
                cursor: 'pointer',
              }}
              onClick={openPopupSteps}
            >
              <picture>
                <source
                  srcSet="/assets/images/2290-steps-img.webp"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <source
                  srcSet="/assets/images/2290-steps-img.png"
                  className="img-responsive"
                  width={915}
                  height={790}
                />
                <img
                  src="/assets/images/2290-steps-img.png"
                  alt="E-File Form 2290 with TaxZerone and receive your IRS Schedule 1 instantly."
                  className="img-responsive"
                  loading="lazy"
                  width={915}
                  height={790}
                />
              </picture>
            </Box>

            <Box
              sx={{
                width: '100%',
              }}
            >
              <Box
                component="ol"
                sx={{
                  [`& .${timelineItemClasses.root}:before`]: {
                    flex: 0,
                    padding: 0,
                  },
                  p: 2,
                  pl: 0,
                  ml: { xs: 0, sm: 0, md: -2 },
                }}
              >
                {/* STEP 1 */}
                <TimelineItem
                  itemProp="step"
                  itemScope
                  itemType="https://schema.org/HowToStep"
                >
                  <meta itemProp="position" content="1" />
                  <link
                    itemProp="image"
                    href="https://www.taxzerone.com/assets/images/step-1-icon.png"
                  />
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        my: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-1-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-1-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-1-icon.png"
                          alt="Enter form information"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      itemProp="name"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Enter form information
                    </Typography>
                    <Typography variant="body1" itemProp="text">
                      Enter the required information, such as name, EIN, VIN,
                      taxable gross weight, and first used month (FUM).
                    </Typography>
                  </TimelineContent>
                </TimelineItem>

                {/* STEP 2 */}
                <TimelineItem
                  itemProp="step"
                  itemScope
                  itemType="https://schema.org/HowToStep"
                >
                  <meta itemProp="position" content="2" />
                  <link
                    itemProp="image"
                    href="https://www.taxzerone.com/assets/images/step-2-icon.png"
                  />
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        m: 0,
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-2-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-2-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-2-icon.png"
                          alt="Review and pay the tax due"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                    <TimelineConnector />
                  </TimelineSeparator>
                  <TimelineContent sx={{ mb: 2 }}>
                    <Typography
                      variant="h3"
                      itemProp="name"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Review and pay the tax due
                    </Typography>
                    <Typography variant="body1" itemProp="text">
                      Review your form information and pay the balance tax due
                      using the EFW or EFTPS or Credit/Debit card option.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>

                {/* STEP 3 */}
                <TimelineItem
                  itemProp="step"
                  itemScope
                  itemType="https://schema.org/HowToStep"
                >
                  <meta itemProp="position" content="3" />
                  <link
                    itemProp="image"
                    href="https://www.taxzerone.com/assets/images/step-3-icon.png"
                  />
                  <TimelineSeparator>
                    <TimelineDot
                      sx={{
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        mt: -1,
                        mb: -1.7,
                      }}
                    >
                      <picture>
                        <source
                          srcSet="/assets/images/step-3-icon.webp"
                          width={39}
                          height={39}
                        />
                        <source
                          srcSet="/assets/images/step-3-icon.png"
                          width={39}
                          height={39}
                        />
                        <img
                          src="/assets/images/step-3-icon.png"
                          alt="Transmit & get Schedule 1"
                          loading="lazy"
                          width={39}
                          height={39}
                        />
                      </picture>
                    </TimelineDot>
                  </TimelineSeparator>
                  <TimelineContent>
                    <Typography
                      variant="h3"
                      itemProp="name"
                      sx={{
                        fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                        fontWeight: 600,
                        mt: 0,
                        mb: 1,
                        color: '#36324a',
                      }}
                    >
                      Transmit & get Schedule 1
                    </Typography>
                    <Typography variant="body1" itemProp="text">
                      Transmit your return to the IRS and get your stamped
                      Schedule 1 as soon as you complete the filing.
                    </Typography>
                  </TimelineContent>
                </TimelineItem>
              </Box>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 17, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  lineHeight: 1.5,
                  textAlign: { xs: 'center', md: 'left' },
                }}
              >
                Filing HUT is a key compliance step in the trucking industry.
                Without a valid Schedule 1, you won’t be able to register or
                renew your vehicle tags. It&apos;s also required during audits
                and DOT inspections.
              </Typography>
              <Box sx={{ textAlign: { xs: 'center', md: 'left' } }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: 4,
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                >
                  E-File Now
                </Button>
                <Typography
                  variant="body2"
                  sx={{ mt: 1, fontSize: { xs: 11, sm: 14 } }}
                >
                  Get Schedule 1 immediately
                </Typography>
              </Box>
            </Box>
          </Stack>
          <Box
            sx={{
              textAlign: { xs: 'center', md: 'center' },
              mb: { xs: 0, sm: 2, md: 5 },
              mt: 3,
            }}
          />
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
        }}
        spacing={2}
        m={0}
        className="dotted-curve"
        component="section"
      >
        <Container maxWidth="lg" sx={{ mb: 5 }}>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignItems="center"
            spacing={2}
            m={2}
            mt={5}
            pb={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12}>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Top reasons to choose TaxZerone for your HVUT filing
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Truckers get countless benefits with TaxZerone. However, here
                are the top benefits.
              </Typography>
            </Grid>
          </Grid>

          <Grid container spacing={2} m={2} mt={4} pb={{ xs: 0, sm: 4, md: 7 }}>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/easy-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/easy-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/easy-icon.png"
                      alt="Easy e-filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Easy e-filing
                </Typography>
                <Typography variant="body1">
                  File your tax return easily and hassle-free. With our
                  user-friendly interface, you can quickly enter your tax
                  details and submit your return within minutes.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/guided-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/guided-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/guided-icon.png"
                      alt="Guided filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Guided filing
                </Typography>
                <Typography variant="body1">
                  Our step-by-step{' '}
                  <Link
                    href="/resources/excise-tax/form-2290-instructions/"
                    sx={{ color: '#0202ff' }}
                  >
                    irs form 2290 instructions
                  </Link>{' '}
                  will guide you to complete your return accurately. This
                  minimizes rejection, ensuring that your tax return is filed
                  the first time correctly.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/smart-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/smart-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/smart-icon.png"
                      alt="Smart validations"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Smart validations
                </Typography>
                <Typography variant="body1">
                  We&apos;ll validate your returns for errors and discrepancies
                  in your tax return. You can correct any errors before
                  transmitting your return, reducing the chances of rejection.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',

                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/secure-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/secure-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/secure-icon.png"
                      alt="Quick and secure e-filing"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Quick and secure e-filing
                </Typography>
                <Typography variant="body1">
                  File the truck tax online with TaxZerone in just 5 minutes and
                  transmit your return to the IRS securely. It&apos;s that
                  simple.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/instant-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/instant-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/instant-icon.png"
                      alt="Instant Schedule 1"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Instant Schedule 1
                </Typography>
                <Typography variant="body1">
                  Get Schedule 1 as soon as you complete the filing process. No
                  more waiting for the paper Schedule 1 to arrive in the mail.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/irs-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/irs-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/irs-icon.png"
                      alt="IRS-authorized"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  IRS-authorized
                </Typography>
                <Typography variant="body1">
                  File HVUT tax Form with an IRS-authorized e-file service
                  provider and stay worry-free that your return will be accepted
                  by the IRS.
                </Typography>
              </Paper>
            </Grid>
            <Hidden mdDown>
              <Grid size={12}>&nbsp;</Grid>
            </Hidden>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,

                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',

                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/upload-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/upload-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/upload-icon.png"
                      alt="Supports bulk upload"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Supports bulk upload
                </Typography>
                <Typography variant="body1">
                  Upload your information, file heavy vehicle use tax in bulk,
                  and complete your filing swiftly and accurately.
                </Typography>
              </Paper>
            </Grid>{' '}
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,

                  borderColor: '#76ce97',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/multiple-pay-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/multiple-pay-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/multiple-pay-icon.png"
                      alt="Multiple Payment Options"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Multiple Payment Options
                </Typography>
                <Typography variant="body1">
                  Choose the method that suits you best, including Electronic
                  Funds Withdrawal (
                  <Link
                    href="/resources/electronic-funds-withdrawal-efw/"
                    sx={{ color: '#0202ff' }}
                  >
                    EFW
                  </Link>
                  ), Electronic Federal Tax Payment System (
                  <Link href="/resources/eftps/" sx={{ color: '#0202ff' }}>
                    EFTPS
                  </Link>
                  ) and Credit or Debit cards.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  borderWidth: 3,
                  borderColor: '#8492c0',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#f0f2f9',
                  mt: { xs: 0, md: 4 },
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/support-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/support-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/support-icon.png"
                      alt="Dedicated Customer Support"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Dedicated Customer Support
                </Typography>
                <Typography variant="body1">
                  Our team of tax experts is always here to answer your
                  questions and guide you through the filing process.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ justifyContent: 'center', my: 3 }}>
          <Grid
            container
            spacing={2}
            m={0}
            mt={4}
            mb={6}
            className="MuiGrid-root-width"
            justifyContent="center"
          >
            <Grid
              size={{ xs: 12, md: 12 }}
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  What Information is Required to Complete IRS Form 2290?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  To file 2290 IRS Form, you must have the following details:
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Business Name & Address"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Business Name & Address
                </Typography>
                <Typography variant="body1" sx={{ mt: 5 }}>
                  Legal name and mailing address exactly as registered with IRS
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Employer Identification Number"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Employer Identification Number (EIN)
                </Typography>
                <Typography variant="body1">
                  Must match IRS records exactly - not your SSN
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="First Used Month (FUM) of a vehicle"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  First Used Month (FUM) of a vehicle
                </Typography>
                <Typography variant="body1">
                  Month your vehicle first operated on a public U.S. highway
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Vehicle Identification Number (VIN)"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Vehicle Identification Number (VIN)
                </Typography>
                <Typography variant="body1">
                  Double-check every character - one wrong digit causes
                  rejection
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  px: 3,
                  pt: 5,
                  pb: 5,
                  textAlign: 'center',
                  // borderWidth: 3,
                  // borderColor: '#626262',
                  borderRadius: 10,
                  minHeight: '100%',
                  backgroundColor: '#fff',
                }}
              >
                {/* <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/get-schedule-1-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/get-schedule-1-icon.png"
                      alt="Taxable Gross Weight"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box> */}
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3,
                  }}
                >
                  Taxable Gross Weight
                </Typography>
                <Typography variant="body1" sx={{ mt: 5 }}>
                  Vehicles weight + maximum load carried on public highway
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box sx={{ backgroundColor: '#fff' }} component="section">
        <Container maxWidth="lg">
          <Grid
            container
            sx={{
              // backgroundColor: '#fff',
              py: { lg: 6, md: 6, sm: 4, xs: 4 },
              mx: '0 !important',
              mb: 0,
            }}
            justifyContent="center"
            spacing={2}
            m={2}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                //  color="white"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                3 Ways to File Your Form 2290 with TaxZerone
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  //  color: '#f3f3f3',
                  mb: 3,
                }}
              >
                Choose the filing method that suits best for you, TaxZerone has
                an option that's right for every truckers.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/single-vehicle-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/single-vehicle-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/single-vehicle-icon.png"
                      alt="Single Vehicle"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3.2,
                  }}
                >
                  Single Vehicle
                </Typography>
                <Typography variant="body1">
                  Filing for a signle truck? Get your return completed in
                  minutes with our simple and guided e-filing process.
                </Typography>
                <Alert
                  severity="warning"
                  icon={false}
                  sx={{
                    textAlign: 'left',
                    mt: 1,
                    borderLeft: '3px solid rgb(102, 60, 0)',
                  }}
                >
                  <b>Note:</b> To report prior-year suspended or credit
                  vehicles, please select Multiple Vehicles.
                </Alert>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/fleet-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/fleet-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/fleet-icon.png"
                      alt="Multiple Vehicles"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 3.2,
                  }}
                >
                  Multiple Vehicles
                </Typography>
                <Typography variant="body1">
                  Filing for{' '}
                  <span style={{ fontWeight: 600 }}> your fleet?</span> Add all
                  your taxable vehicles in a single return with our{' '}
                  <span style={{ fontWeight: 600 }}> bulk upload feature.</span>
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 4 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 3,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#f0f2f9',
                }}
              >
                <Box
                  sx={{
                    backgroundColor: '#fff',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 60, height: 60 }}>
                    <source
                      srcSet="/assets/images/auto-magic-icon.webp"
                      width={60}
                      height={60}
                    />
                    <source
                      srcSet="/assets/images/auto-magic-icon.png"
                      width={60}
                      height={60}
                    />
                    <img
                      src="/assets/images/auto-magic-icon.png"
                      alt="Auto Magic 2290"
                      loading="lazy"
                      width={60}
                      height={60}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                    fontWeight: 600,
                    my: 2,
                  }}
                >
                  Auto Magic 2290
                  <br />
                  <span style={{ fontWeight: 400, fontSize: 14 }}>
                    (Upload prior-year Schedule 1)
                  </span>
                </Typography>
                <Typography variant="body1">
                  Upload your prior-year IRS-stamped Schedule 1 and our system
                  auto-fills your entire return using{' '}
                  <Link
                    href={`${process.env.NEXT_PUBLIC_AUTOMAGIC_SITE_URL}?ref=form2290`}
                    target="_blank"
                    sx={{ color: '#0202ff' }}
                  >
                    {' '}
                    Auto Magic 2290
                  </Link>
                  . No manual entry.
                </Typography>
              </Paper>
            </Grid>

            <Grid size={12}>
              <Box
                component="div"
                sx={{
                  margin: 'auto',
                  textAlign: 'center',
                  mt: 4,
                  mb: { xs: 0, md: 0 },
                }}
              >
                <Button
                  variant="contained"
                  sx={{
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  className="btn-primary medium"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                >
                  E-File Now
                </Button>
                {/* <Typography
                  variant="body2"
                  sx={{ mt: 1, mb: { xs: 2, md: 0 } }}
                  //  color="#dfeae1"
                >
                  Get Schedule 1 in minutes
                </Typography> */}
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Box sx={{ backgroundColor: '#f0f2f9' }} component="section">
        <Container maxWidth="lg">
          <Grid
            container
            sx={{
              // backgroundColor: '#fff',
              py: { lg: 6, md: 6, sm: 4, xs: 4 },
              mx: '0 !important',
              mb: 0,
            }}
            justifyContent="center"
            spacing={2}
            m={2}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                //  color="white"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Affordable Pricing for Every Fleet Size
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  //  color: '#f3f3f3',
                  mb: 3,
                }}
              >
                Choose the filing option that fits your fleet size.
              </Typography>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 19, md: 17, sm: 17, xs: 17 },
                    fontWeight: 600,
                    my: 2,
                  }}
                >
                  Single Vehicle
                </Typography>
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 70, height: 70 }}>
                    <source
                      srcSet="/assets/images/single-vehicle-icon.webp"
                      width={70}
                      height={70}
                    />
                    <source
                      srcSet="/assets/images/single-vehicle-icon.png"
                      width={70}
                      height={70}
                    />
                    <img
                      src="/assets/images/single-vehicle-icon.png"
                      alt="Single Vehicle"
                      loading="lazy"
                      width={70}
                      height={70}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: 16,
                    fontWeight: 400,
                    my: 2,
                  }}
                >
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: '45px',
                      color: '#1da94a',
                    }}
                  >
                    {' '}
                    $19.99
                  </span>
                  /return
                </Typography>
                <Typography variant="body1">
                  Perfect for owner-operators
                </Typography>
                <Box
                  sx={{
                    mt: 5,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                  >
                    E-File Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',

                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#fff',
                  position: 'relative',
                  borderWidth: 2,
                  borderColor: '#626262',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    position: 'absolute',
                    backgroundColor: '#ffd166',
                    p: '3px 10px',
                    borderRadius: 1.5,
                    top: 8,
                    right: 'auto',
                    left: '10px',
                    justifyContent: 'center',
                    alignItems: 'center',
                    textAlign: 'center',
                    mx: 0,
                    display: 'grid',
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{
                      fontWeight: 500,
                      color: '#333',
                      textAlign: 'center',
                      fontSize: 14,
                    }}
                  >
                    Most Popular
                  </Typography>
                </Box>
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 19, md: 17, sm: 17, xs: 17 },
                    fontWeight: 600,
                    my: 2,
                  }}
                >
                  3 to 5 Vehicles
                </Typography>
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 70, height: 70 }}>
                    <source
                      srcSet="/assets/images/3more-vehicle-icon.webp"
                      width={70}
                      height={70}
                    />
                    <source
                      srcSet="/assets/images/3more-vehicle-icon.png"
                      width={70}
                      height={70}
                    />
                    <img
                      src="/assets/images/3more-vehicle-icon.png"
                      alt="3 to 5 Vehicles"
                      loading="lazy"
                      width={70}
                      height={70}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: 16,
                    fontWeight: 400,
                    my: 2,
                  }}
                >
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: '45px',
                      color: '#1da94a',
                    }}
                  >
                    {' '}
                    $29.99
                  </span>
                  /return
                </Typography>
                <Typography variant="body1">
                  Ideal for growing fleets.
                </Typography>
                <Box
                  sx={{
                    mt: 5,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                  >
                    E-File Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 19, md: 17, sm: 17, xs: 17 },
                    fontWeight: 600,
                    my: 2,
                  }}
                >
                  6 to 10 Vehicles
                </Typography>
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 70, height: 70 }}>
                    <source
                      srcSet="/assets/images/6more-vehicle-icon.webp"
                      width={70}
                      height={70}
                    />
                    <source
                      srcSet="/assets/images/6more-vehicle-icon.png"
                      width={70}
                      height={70}
                    />
                    <img
                      src="/assets/images/6more-vehicle-icon.png"
                      alt="6 to 10 Vehicles"
                      loading="lazy"
                      width={70}
                      height={70}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: 16,
                    fontWeight: 400,
                    my: 2,
                  }}
                >
                  <span
                    style={{
                      fontWeight: 700,
                      fontSize: '45px',
                      color: '#1da94a',
                    }}
                  >
                    {' '}
                    $39.99
                  </span>
                  /return
                </Typography>
                <Typography variant="body1">
                  Perfect for established fleet operators.
                </Typography>
                <Box
                  sx={{
                    mt: 2,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                  >
                    E-File Now!
                  </Button>
                </Box>
              </Paper>
            </Grid>
            <Grid size={{ xs: 12, sm: 4, md: 3 }}>
              <Paper
                variant="outlined"
                sx={{
                  p: 3,
                  py: 5,
                  textAlign: 'center',
                  borderWidth: 2,
                  borderColor: 'transparent',
                  borderRadius: 5,
                  height: '100%',
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontSize: { lg: 19, md: 17, sm: 17, xs: 17 },
                    fontWeight: 600,
                    my: 2,
                  }}
                >
                  More than 10 Vehicles
                </Typography>
                <Box
                  sx={{
                    backgroundColor: '#f0f2f9',
                    borderRadius: '50%',
                    width: 90,
                    height: 90,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mx: 'auto',
                  }}
                >
                  <picture style={{ width: 70, height: 70 }}>
                    <source
                      srcSet="/assets/images/10more-vehicle-icon.webp"
                      width={70}
                      height={70}
                    />
                    <source
                      srcSet="/assets/images/10more-vehicle-icon.png"
                      width={70}
                      height={70}
                    />
                    <img
                      src="/assets/images/10more-vehicle-icon.png"
                      alt="More than 10 Vehicles"
                      loading="lazy"
                      width={70}
                      height={70}
                    />
                  </picture>
                </Box>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: 18,
                    fontWeight: 400,
                    my: 5.5,
                  }}
                >
                  Need to file for a larger fleet?
                </Typography>

                <Box
                  sx={{
                    mt: 8,
                  }}
                >
                  <Button
                    size="large"
                    variant="contained"
                    sx={{
                      borderRadius: 4,
                      backgroundColor: '#1da94a',
                      textTransform: 'none',
                      boxShadow: 'none',
                      transition: 'all 0.3s ease 0s',
                      '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                    }}
                    href="/pricing/#excise"
                  >
                    View Full Pricing
                  </Button>
                </Box>
              </Paper>
            </Grid>

            <Grid
              size={12}
              sx={{ justifyContent: 'center', textAlign: 'center' }}
            >
              <Stack
                spacing={2}
                direction={{ md: 'row', sm: 'row', xs: 'column' }}
                sx={{ textAlign: 'center', justifyContent: 'center' }}
              >
                <Box sx={{ display: 'flex', gap: { md: 1, sm: 0.5 } }}>
                  <VerifiedIcon
                    sx={{ fontSize: 30, mt: -0.5, color: '#184e77' }}
                  />
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 15 }}
                  >
                    {' '}
                    IRS-stamped Schedule 1
                  </Typography>{' '}
                </Box>

                <Box sx={{ display: 'flex', gap: 1 }}>
                  <VerifiedIcon
                    sx={{ fontSize: 30, mt: -0.5, color: '#5a189a' }}
                  />
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 16 }}
                  >
                    {' '}
                    Same-day IRS processing{' '}
                  </Typography>{' '}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <VerifiedIcon
                    sx={{ fontSize: 30, mt: -0.5, color: '#40916c' }}
                  />
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 16 }}
                  >
                    {' '}
                    Free VIN corrections{' '}
                  </Typography>{' '}
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                  <VerifiedIcon sx={{ fontSize: 30, mt: -0.5 }} />
                  <Typography
                    variant="body1"
                    sx={{ fontWeight: 600, fontSize: 16 }}
                  >
                    {' '}
                    Free Retransmission{' '}
                  </Typography>{' '}
                </Box>
              </Stack>
            </Grid>

            <Stack
              spacing={2}
              direction={{ md: 'row', xs: 'column' }}
              sx={{
                mt: 2,
                backgroundColor: '#1b263b',
                px: 3,
                py: 2.8,
                borderRadius: 3,
                justifyContent: 'center',
                alignItems: 'center',
              }}
              className="curve-bg"
            >
              <Box>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 600,
                    fontSize: { md: 20, sm: 19, xs: 17, mb: 0.8 },
                    color: '#f1f1f1',
                    mb: 1,
                  }}
                >
                  Are You a Tax Professional or CPA Filing Multiple Form 2290s?
                </Typography>
                <Typography variant="body1" sx={{ color: '#dddddd' }}>
                  We offer special exclusive pricing for CPAs and Tax Pros.
                  Contact us to lock in your rate today.
                </Typography>
              </Box>
              <Box>
                <Button
                  size="large"
                  variant="contained"
                  sx={{
                    borderRadius: 4,
                    textTransform: 'none',
                    boxShadow: 'none',
                    backgroundColor: '#fff !important',
                    color: '#333',
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &:focus, &:active': { transform: 'scale(1.1)' },
                  }}
                  target="_blank"
                  href="/contact-us/"
                >
                  Contact Us
                </Button>
              </Box>
            </Stack>
          </Grid>
        </Container>
      </Box>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          py: 0,
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Get the TaxZerone 2290 App - Available on Android, iPhone, and
                  iPad.
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  The TaxZerone mobile app gives you flexibility and control
                  over your HVUT filings from anywhere.
                </Typography>
                <Typography component="div" variant="body1" sx={{ mb: 3 }}>
                  <ul
                    style={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                    }}
                  >
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Complete and submit your return in minutes
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Instantly access your Schedule 1
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      View past filings on your phone
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Get real-time updates on your return status
                    </li>
                  </ul>
                </Typography>

                <Typography
                  variant="body1"
                  color="secondary"
                  sx={{ fontWeight: 600 }}
                >
                  Download the app on Android or iOS and take your HVUT filing
                  on the road- anytime, anywhere.
                </Typography>
                <Box
                  sx={{
                    my: 1,
                    mb: 0,
                    '& img': {
                      width: { xs: 120, sm: 180 },
                      height: { xs: 37, sm: 55 },
                    },
                  }}
                >
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.taxzerone.excisetaxes"
                    target="_blank"
                    sx={{
                      mr: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Available on the Google Play" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/play-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/play-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/play-store-img.png"
                          alt="Available on the Google Play"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                  <Link
                    href="https://apps.apple.com/us/app/e-file-form-2290-pay-hvut/id6450998674"
                    target="_blank"
                    sx={{
                      ml: { xs: 1, sm: 1 },
                      my: { xs: 0, sm: 0 },
                      display: 'inline-block',
                    }}
                  >
                    <Tooltip title="Download on the App Store" arrow>
                      <picture>
                        <source
                          srcSet="/assets/images/app-store-img.webp"
                          width={180}
                          height={55}
                        />
                        <source
                          srcSet="/assets/images/app-store-img.png"
                          width={180}
                          height={55}
                        />
                        <img
                          src="/assets/images/app-store-img.png"
                          alt="Download on the App Store"
                          width={180}
                          height={55}
                        />
                      </picture>
                    </Tooltip>
                  </Link>
                </Box>
                <Typography
                  variant="body2"
                  sx={{ mt: 0, mb: { xs: 2, md: 2 } }}
                  //  color="#dfeae1"
                >
                  Haul in the high-speed express lane for HVUT filing!
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/2290-mobile-app-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/2290-mobile-app-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/2290-mobile-app-img.png"
                    alt="Get the TaxZerone 2290 App - Available on Android, iPhone, and iPad."
                    className="img-responsive"
                    loading="lazy"
                    width={657}
                    height={770}
                  />
                </picture>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { md: 8, sm: 4, xs: 2 },
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid size={{ md: 6, xs: 12 }} textAlign="right">
              <Box
                component="div"
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100%',
                }}
              >
                <picture>
                  <source
                    srcSet="/assets/images/amendment-img.webp"
                    className="img-responsive"
                  />
                  <source
                    srcSet="/assets/images/amendment-img.png"
                    className="img-responsive"
                  />
                  <img
                    src="/assets/images/amendment-img.png"
                    alt="Avoid these common filing mistakes on Form 2290"
                    className="img-responsive img-shadow"
                    loading="lazy"
                    width={545}
                    height={490}
                    style={{ borderRadius: '24px' }}
                  />
                </picture>
              </Box>
            </Grid>
            <Grid
              size={{ xs: 12, md: 6 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Why an IRS Watermarked Schedule 1 is Important for Truckers?
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  You will need a stamped Schedule 1 for:
                </Typography>
                <Typography component="div" variant="body1" sx={{ mb: 3 }}>
                  <ul
                    style={{
                      listStyleType: 'none',
                      paddingLeft: 0,
                      textAlign: 'left',
                    }}
                  >
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1, mb: 0 }}
                      />{' '}
                      <Box>
                        Registering a new heavy vehicle with your state DMV
                      </Box>
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Renewing truck or fleet registration
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Passing roadside DOT inspections
                    </li>
                    <li
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        marginBottom: 10,
                      }}
                    >
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Providing proof of HVUT compliance during audits
                    </li>
                    <li style={{ display: 'flex', alignItems: 'center' }}>
                      <CheckCircleRoundedIcon
                        sx={{ color: '#1da94a', mr: 1 }}
                      />{' '}
                      Operating legally on U.S. highways for vehicles 55,000 lbs
                      or more
                    </li>
                  </ul>
                </Typography>

                <Typography variant="body1" color="secondary" sx={{}}>
                  Without a valid Schedule 1, state authorities may deny
                  registration or renewal of your vehicle.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Box sx={{ backgroundColor: '#fff' }} component="section">
        <Container
          maxWidth="lg"
          sx={{
            pt: 6,
            pb: 6,
          }}
        >
          <Typography
            variant="h2"
            sx={{
              fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
              fontWeight: 600,
              mb: 1,
              mt: 2,
              textAlign: 'center',
            }}
          >
            Why TaxZerone is the Best Choice for Your HVUT Filing?
          </Typography>
          <Box component="div" sx={{ mb: 2, maxWidth: 1000, m: 'auto' }}>
            <TableContainer sx={{}}>
              <Table sx={{}} aria-label="Due Date Chart">
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#ccc', fontWeight: 600 }}>
                    <TableCell
                      sx={{
                        color: '#444',
                        width: 300,
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      Feature
                    </TableCell>
                    <TableCell
                      sx={{
                        color: '#444',
                        width: 300,
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      TaxZerone
                    </TableCell>

                    <TableCell
                      sx={{
                        color: '#444',
                        width: 300,
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      Other E-File Platforms
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  <TableRow sx={{}}>
                    <TableCell>IRS -Authorized </TableCell>
                    <TableCell>✅ Yes </TableCell>

                    <TableCell>✅ Yes </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>AICPA SOC II Certified Security </TableCell>
                    <TableCell>✅ Yes </TableCell>
                    <TableCell>⚠️ Limited </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Priority IRS Processing </TableCell>
                    <TableCell>✅ Included </TableCell>
                    <TableCell>⚠️ Available on Select Plans </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Schedule 1 Delivery </TableCell>

                    <TableCell>⚡ In Minutes </TableCell>
                    <TableCell>⏱️ Usually Within 5 Minutes </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Free VIN Checker </TableCell>
                    <TableCell>✅ Included </TableCell>
                    <TableCell>✅ Included </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Free VIN Correction </TableCell>

                    <TableCell>✅ Included </TableCell>
                    <TableCell>
                      {' '}
                      ⚠️ Limited / Additional Charges May Apply{' '}
                    </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Form 8849 Support </TableCell>
                    <TableCell>✅ Yes </TableCell>
                    <TableCell>✅ Yes </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell> Amendment Support </TableCell>

                    <TableCell>✅ Yes </TableCell>
                    <TableCell> ✅ Yes</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Free Retransmission (if rejected) </TableCell>
                    <TableCell>✅ Included </TableCell>
                    <TableCell>⚠️ Limited </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Built-in Error Checks </TableCell>

                    <TableCell>✅ Yes </TableCell>
                    <TableCell> ✅ Yes</TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Copy Previous Return Details </TableCell>
                    <TableCell>✅ Yes </TableCell>
                    <TableCell>⚠️ Limited </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Bulk Upload </TableCell>

                    <TableCell>✅ Yes </TableCell>
                    <TableCell> ⚠️ Limited </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Bulk Filing </TableCell>
                    <TableCell>✅ Yes </TableCell>
                    <TableCell>⚠️ Limited </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>Buy credits for vehicle </TableCell>

                    <TableCell>✅ Yes </TableCell>
                    <TableCell> ⚠️ Limited </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Mobile App </TableCell>

                    <TableCell>✅ Yes </TableCell>
                    <TableCell> ⚠️ Limited </TableCell>
                  </TableRow>
                  <TableRow sx={{ backgroundColor: '#f9f9f9' }}>
                    <TableCell>HVUT Tax Calculator </TableCell>
                    <TableCell>✅ Yes </TableCell>
                    <TableCell>✅ Yes </TableCell>
                  </TableRow>
                  <TableRow sx={{}}>
                    <TableCell>Customer Support </TableCell>

                    <TableCell>✅ Yes </TableCell>
                    <TableCell> ⚠️ Limited </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Alert
            icon={false}
            severity="warning"
            sx={{ mt: 4, mb: 4, borderLeft: '3px solid rgb(102, 60, 0)' }}
          >
            <b>Note:</b> TaxZerone offers the perfect balance of compliance,
            convenience, and cost for HVUT filers. Don’t settle for outdated or
            overpriced alternatives.
          </Alert>
        </Container>
      </Box>

      <Grid
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { md: 8, sm: 4, xs: 2 },
        }}
        spacing={0}
        m={0}
        component="section"
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, md: 12 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'center',
                  md: 'center',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Box sx={{ mb: { xs: 3, md: 0 }, mt: { xs: -3, md: 0 } }}>
                <Typography
                  variant="h2"
                  sx={{
                    fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                    fontWeight: 600,
                    mb: 3,
                  }}
                >
                  Avoid These Common Filing Mistakes{' '}
                  <Hidden smDown>
                    {' '}
                    <br />
                  </Hidden>{' '}
                  That can Delay your Schedule 1
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                    fontWeight: 400,
                    color: '#333333',
                    mb: 3,
                  }}
                >
                  Even small mistakes can lead to IRS rejections. Here are the
                  most common errors and how to avoid them:
                </Typography>
              </Box>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  py: 3,
                  px: 3,
                  borderRadius: 4,
                  minHeight: '100%',
                  borderLeft: '4px solid #c9184a',
                  backgroundColor: '#fff0f3',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    m: 0,
                    p: 0,
                    fontSize: 15,
                    fontWeight: 600,
                    lineHeight: 1.4,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <ClearIcon
                    sx={{
                      fontSize: 30,
                      mb: -1,
                      color: '#c9184a',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  />{' '}
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: 600,
                      marginTop: 4,
                    }}
                  >
                    EIN mismatch:
                  </span>
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: 2,
                    lineHeight: 1.5,
                  }}
                >
                  Using an EIN that doesn't exactly match IRS records - or using
                  your Social Security Number instead.
                </Typography>

                <Typography variant="body2">
                  <CheckBoxIcon
                    sx={{
                      fontSize: 30,
                      mb: -1,
                      color: '#40916c',
                    }}
                  />{' '}
                  <strong style={{ fontWeight: 600, fontSize: 15 }}>
                    Fix:
                  </strong>
                  <br />
                  Verify your EIN with the IRS before filing. TaxZerone
                  validates it automatically
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  py: 3,
                  px: 3,
                  borderRadius: 4,
                  minHeight: '100%',
                  borderLeft: '4px solid #c9184a',
                  backgroundColor: '#fff0f3',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    m: 0,
                    p: 0,
                    fontSize: 15,
                    fontWeight: 600,
                    lineHeight: 1.4,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <ClearIcon
                    sx={{
                      fontSize: 30,
                      mb: -1,
                      color: '#c9184a',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  />{' '}
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: 600,
                      marginTop: 4,
                    }}
                  >
                    Incorrect VIN:
                  </span>
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: 2,
                    lineHeight: 1.5,
                  }}
                >
                  Even one wrong character in your 17-digit VIN will cause an
                  IRS rejection.
                </Typography>
                <Typography variant="body2">
                  <CheckBoxIcon
                    sx={{ fontSize: 30, mb: -1, color: '#40916c' }}
                  />{' '}
                  <strong style={{ fontWeight: 600, fontSize: 15 }}>
                    {' '}
                    Fix:
                  </strong>
                  <br />
                  Use our free VIN checker before filing. Free VIN corrections
                  are included if you make an error.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  py: 3,
                  px: 3,
                  borderRadius: 4,
                  minHeight: '100%',
                  borderLeft: '4px solid #c9184a',
                  backgroundColor: '#fff0f3',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    m: 0,
                    p: 0,
                    fontSize: 15,
                    fontWeight: 600,
                    lineHeight: 1.4,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <ClearIcon
                    sx={{
                      fontSize: 30,
                      mb: -1,
                      color: '#c9184a',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  />{' '}
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: 600,
                      marginTop: 4,
                    }}
                  >
                    Wrong First Used Month:
                  </span>
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: 2,
                    lineHeight: 1.5,
                  }}
                >
                  Selecting the wrong FUM changes your tax liability and your
                  filing deadline.
                </Typography>
                <Typography variant="body2">
                  <CheckBoxIcon
                    sx={{ fontSize: 30, mb: -1, color: '#40916c' }}
                  />{' '}
                  <strong style={{ fontWeight: 600, fontSize: 15 }}>
                    {' '}
                    Fix:
                  </strong>
                  <br />
                  Select the month the vehicle first operated on a public
                  highway - not the purchase date.
                </Typography>
              </Paper>
            </Grid>
            <Grid size={{ md: 3, sm: 6, xs: 12 }}>
              <Paper
                variant="outlined"
                sx={{
                  py: 3,
                  px: 3,
                  borderRadius: 4,
                  minHeight: '100%',
                  borderLeft: '4px solid #c9184a',
                  backgroundColor: '#fff0f3',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    m: 0,
                    p: 0,
                    fontSize: 15,
                    fontWeight: 600,
                    lineHeight: 1.4,
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                  }}
                >
                  <ClearIcon
                    sx={{
                      fontSize: 30,
                      mb: -1,
                      color: '#c9184a',
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  />{' '}
                  <span
                    style={{
                      fontSize: '15px',
                      fontWeight: 600,
                      marginTop: 4,
                    }}
                  >
                    Filing Late:
                  </span>
                </Typography>

                <Typography
                  variant="body2"
                  sx={{
                    mt: 1,
                    mb: 2,
                    lineHeight: 1.5,
                  }}
                >
                  Missing the deadline trigger a 4.5% monthly penalty plus 0.5%
                  interest charges form the IRS.
                </Typography>
                <Typography variant="body2">
                  <CheckBoxIcon
                    sx={{ fontSize: 30, mb: -1, color: '#40916c' }}
                  />{' '}
                  <strong style={{ fontWeight: 600, fontSize: 15 }}>
                    {' '}
                    Fix:
                  </strong>
                  <br />
                  File now. Even late filing is better than no filing -
                  penalties stop accruing once you submit.
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        </Container>
      </Grid>

      <Grid
        container
        sx={{
          backgroundColor: '#fff',
          mx: '0 !important',
          width: '100% !important',
          backgroundPosition: 'center bottom',
        }}
        spacing={2}
        m={0}
        component="section"
      >
        <Container maxWidth="lg" sx={{ px: { xs: 0, sm: 2 } }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={{ xs: 5, sm: 5, md: 6 }}
            mb={{ xs: 5, sm: 5, md: 8 }}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Stack
                direction="row"
                spacing={1}
                sx={{ mb: 2 }}
                justifyContent={{ xs: 'center', md: 'center' }}
              >
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-1"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-2"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-3"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-4"
                />
                <img
                  src="/assets/images/star-icon.svg"
                  width={30}
                  height={28}
                  alt="star-5"
                />
              </Stack>
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: { xs: 1, sm: 3 },
                }}
              >
                Driving Success: Truckers share their experience with TaxZerone
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#333333',
                  mb: 3,
                  textAlign: 'center',
                }}
              >
                Read the satisfied truckers&apos; testimonials and see why
                TaxZerone is the trusted choice for stress-free e-filing.
              </Typography>

              <Box itemScope itemType="https://schema.org/Product">
                {/* PRODUCT NAME */}
                <meta itemProp="name" content="TaxZerone" />

                {/* AGGREGATE RATING (Standardized for Rich Snippets) */}
                <Box
                  itemProp="aggregateRating"
                  itemScope
                  itemType="https://schema.org/AggregateRating"
                >
                  <meta itemProp="ratingValue" content="5" />
                  <meta itemProp="reviewCount" content="3" />
                  <meta itemProp="bestRating" content="5" />
                  <meta itemProp="worstRating" content="1" />
                </Box>

                <Grid
                  container
                  spacing={2}
                  m={0}
                  justifyContent="center"
                  direction="row"
                  className="MuiGrid-root-width"
                >
                  {/* REVIEW 1 */}
                  <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Paper
                      elevation={0}
                      itemScope
                      itemType="https://schema.org/Review"
                      itemProp="review"
                      sx={{
                        backgroundColor: '#f0f2f9',
                        p: 2,
                        borderRadius: 3,
                        minHeight: '100%',
                      }}
                    >
                      <meta itemProp="datePublished" content="2026-04-03" />

                      {/* Structured Review Rating */}
                      <Box
                        itemProp="reviewRating"
                        itemScope
                        itemType="https://schema.org/Rating"
                      >
                        <meta itemProp="ratingValue" content="5" />
                        <meta itemProp="bestRating" content="5" />
                        <meta itemProp="worstRating" content="1" />
                      </Box>

                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{ my: 1 }}
                        justifyContent={{ xs: 'center', md: 'center' }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &ldquo;
                        </Typography>
                        <Typography
                          component="div"
                          variant="body1"
                          color="gray"
                          itemProp="reviewBody"
                          sx={{
                            fontSize: { xs: 16, sm: 18, md: 20 },
                            fontFamily: 'san-serif',
                            fontStyle: 'italic',
                            color: '#414042',
                            lineHeight: 1.2,
                          }}
                        >
                          HVUT Filing with TaxZerone was much easier than I
                          expected. The process was straightforward, and I
                          received my IRS-stamped Schedule 1 within minutes.
                          Highly recommended!{' '}
                          <Stack
                            direction="row"
                            spacing={1}
                            sx={{ mt: 2 }}
                            justifyContent={{ xs: 'center', md: 'center' }}
                          >
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-1"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-2"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-3"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-4"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-5"
                            />
                          </Stack>
                          <Typography
                            variant="body1"
                            itemProp="author"
                            itemScope
                            itemType="https://schema.org/Person"
                            sx={{
                              mt: 0.8,
                              fontWeight: 600,
                              textAlign: 'right',
                            }}
                          >
                            -{' '}
                            <Box component="span" itemProp="name">
                              Mike Thompson
                            </Box>
                          </Typography>
                        </Typography>
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &rdquo;
                        </Typography>
                      </Stack>
                    </Paper>
                  </Grid>

                  {/* REVIEW 2 */}
                  <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Paper
                      elevation={0}
                      itemScope
                      itemType="https://schema.org/Review"
                      itemProp="review"
                      sx={{
                        backgroundColor: '#f0f2f9',
                        p: 2,
                        borderRadius: 3,
                        minHeight: '100%',
                      }}
                    >
                      <meta itemProp="datePublished" content="2026-04-03" />

                      <Box
                        itemProp="reviewRating"
                        itemScope
                        itemType="https://schema.org/Rating"
                      >
                        <meta itemProp="ratingValue" content="5" />
                        <meta itemProp="bestRating" content="5" />
                        <meta itemProp="worstRating" content="1" />
                      </Box>

                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{ my: 1 }}
                        justifyContent={{ xs: 'center', md: 'center' }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &ldquo;
                        </Typography>
                        <Typography
                          component="div"
                          variant="body1"
                          color="gray"
                          itemProp="reviewBody"
                          sx={{
                            fontSize: { xs: 16, sm: 18, md: 20 },
                            fontFamily: 'san-serif',
                            fontStyle: 'italic',
                            color: '#414042',
                            lineHeight: 1.2,
                          }}
                        >
                          Great experience using TaxZerone for my HVUT filing.
                          The platform was user-friendly, and customer support
                          answered my questions quickly.{' '}
                          <Stack
                            direction="row"
                            spacing={1}
                            sx={{ mt: 2 }}
                            justifyContent={{ xs: 'center', md: 'center' }}
                          >
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-1"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-2"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-3"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-4"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-5"
                            />
                          </Stack>
                        </Typography>
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &rdquo;
                        </Typography>
                      </Stack>
                      <Typography
                        variant="body1"
                        itemProp="author"
                        itemScope
                        itemType="https://schema.org/Person"
                        sx={{ fontWeight: 600, mt: 7, textAlign: 'right' }}
                      >
                        -{' '}
                        <Box component="span" itemProp="name">
                          Jeffrey Coleman
                        </Box>
                      </Typography>
                    </Paper>
                  </Grid>

                  {/* REVIEW 3 */}
                  <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                    <Paper
                      elevation={0}
                      itemScope
                      itemType="https://schema.org/Review"
                      itemProp="review"
                      sx={{
                        backgroundColor: '#f0f2f9',
                        p: 2,
                        borderRadius: 3,
                        minHeight: '100%',
                      }}
                    >
                      <meta itemProp="datePublished" content="2026-04-03" />

                      <Box
                        itemProp="reviewRating"
                        itemScope
                        itemType="https://schema.org/Rating"
                      >
                        <meta itemProp="ratingValue" content="5" />
                        <meta itemProp="bestRating" content="5" />
                        <meta itemProp="worstRating" content="1" />
                      </Box>

                      <Stack
                        direction="row"
                        spacing={1}
                        sx={{ my: 1 }}
                        justifyContent={{ xs: 'center', md: 'center' }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &ldquo;
                        </Typography>
                        <Typography
                          component="div"
                          variant="body1"
                          color="gray"
                          itemProp="reviewBody"
                          sx={{
                            fontSize: { xs: 16, sm: 18, md: 20 },
                            fontFamily: 'san-serif',
                            fontStyle: 'italic',
                            color: '#414042',
                            lineHeight: 1.2,
                          }}
                        >
                          I’ve tried different 2290 filing services before, but
                          TaxZerone made everything simple and quick. The
                          step-by-step process saved me a lot of time during the
                          renewal season.
                          <Stack
                            direction="row"
                            spacing={1}
                            sx={{ mt: 2 }}
                            justifyContent={{ xs: 'center', md: 'center' }}
                          >
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-1"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-2"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-3"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-4"
                            />
                            <img
                              src="/assets/images/star-icon.svg"
                              width={18}
                              height={17}
                              alt="star-5"
                            />
                          </Stack>
                        </Typography>
                        <Typography
                          component="span"
                          sx={{
                            fontFamily: 'san-serif',
                            fontSize: { xs: 45, sm: 65 },
                            fontWeight: 600,
                            lineHeight: { xs: '30px', sm: '65px' },
                            color: '#999',
                          }}
                        >
                          &rdquo;
                        </Typography>
                      </Stack>
                      <Typography
                        variant="body1"
                        itemProp="author"
                        itemScope
                        itemType="https://schema.org/Person"
                        sx={{ fontWeight: 600, mt: 4, textAlign: 'right' }}
                      >
                        -{' '}
                        <Box component="span" itemProp="name">
                          Charles Morris
                        </Box>
                      </Typography>
                    </Paper>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Box
        sx={{
          backgroundColor: '#1da94a',
          py: { lg: 8, md: 8, sm: 4, xs: 4 },
          mx: '0 !important',
          mb: 0,
        }}
        className="curve-bg"
        component="section"
      >
        <Container sx={{ maxWidth: '1000px !important' }}>
          <Grid
            container
            spacing={2}
            m={2}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid size={12} textAlign="center">
              <Typography
                variant="h2"
                color="white"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Get the Forms You Need: Form 2290 PDF
              </Typography>

              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 24, md: 22, sm: 20, xs: 18 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 3,
                }}
              >
                Download the official forms and instructions directly from the
                IRS website
              </Typography>
              <Box
                component="ul"
                sx={{
                  color: '#f3f3f3',
                  textAlign: 'left',
                  listStyleType: 'none',
                }}
              >
                <li style={{ marginBottom: 12 }}>
                  <CheckCircleOutlineIcon sx={{ mr: 1, mb: -0.7 }} />
                  For Form{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/f2290.pdf"
                    target="_blank"
                    sx={{ color: '#000' }}
                  >
                    Download PDF
                  </Link>
                </li>
                <li>
                  <CheckCircleOutlineIcon sx={{ mr: 1, mb: -0.7 }} />
                  For Instructions{' '}
                  <Link
                    href="https://www.irs.gov/pub/irs-pdf/i2290.pdf"
                    target="_blank"
                    sx={{ color: '#000' }}
                  >
                    Download PDF
                  </Link>
                </li>
              </Box>
              <Typography
                variant="h3"
                sx={{
                  fontSize: { lg: 24, md: 22, sm: 20, xs: 18 },
                  fontWeight: 600,
                  color: '#fff',
                  mb: 1,
                  mt: 5,
                  lineHeight: 1.5,
                }}
              >
                America&apos;s #1 E-Filing Platform
              </Typography>
              <Typography
                variant="body1"
                sx={{
                  fontSize: { lg: 18, md: 18, sm: 16, xs: 16 },
                  fontWeight: 400,
                  color: '#f3f3f3',
                  mb: 3,
                }}
              >
                E-filing is more than just a trend, it&apos;s a smarter way to
                file. So, switch to e-file and embrace the future!
              </Typography>
              <Box component="div" sx={{ margin: 'auto' }}>
                <Button
                  variant="contained"
                  sx={{
                    mt: { xs: 0, sm: 0 },
                    mb: { xs: 0, md: 0 },
                    color: '#444',
                    transition: 'all 0.3s ease 0s',
                    '&:hover, &active': {
                      backgroundColor: '#213e99 !important',
                      color: '#fff',
                      transform: 'scale(1.1)',
                    },
                  }}
                  className="btn-secondary-white"
                  href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signup/?ref=form2290`}
                >
                  E-File and Get Schedule 1 Now
                </Button>
                <Typography
                  variant="body2"
                  sx={{ mt: 1, mb: { xs: 0, md: 0 } }}
                  color="#dfeae1"
                >
                  Take the first step to discover the simplicity of e-filing.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
      <Container
        maxWidth="lg"
        component="section"
        aria-labelledby="hvut-online-faqs"
      >
        <Grid
          container
          spacing={2}
          m={2}
          direction="row"
          justifyContent="center"
          className="MuiGrid-root-width"
          sx={{ my: { xs: 0, sm: 2 } }}
        >
          <Grid
            size={{ xs: 12, sm: 10, md: 9 }}
            textAlign="left"
            my={{ xs: 2, sm: 5 }}
            mb={3}
          >
            <Typography
              variant="h2"
              id="hvut-online-faqs"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: 5,
                textAlign: 'center',
              }}
            >
              Frequently Asked Questions
            </Typography>
            <Box
              component="div"
              sx={{ mb: 5 }}
              itemScope
              itemType="https://schema.org/FAQPage"
            >
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  1. Who should file Form 2290?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    Truckers who own or operate heavy vehicles with a gross
                    weight of 55,000 pounds or more on public highways must file
                    HUVT Form. Additionally, those who expect to use the vehicle
                    for 5,000 miles or more (7,500 miles or more for
                    agricultural vehicles) during the tax period should also
                    file this form.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  2. What is Form 2290 Schedule 1?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    <Link
                      href="/resources/excise-tax/form-2290-schedule-1/"
                      sx={{ color: '#0202ff' }}
                    >
                      {' '}
                      Form 2290 Schedule 1
                    </Link>{' '}
                    is a proof of payment document issued by the IRS after
                    successfully filing and paying the Heavy Highway Vehicle Use
                    Tax (HVUT). It contains important details about the vehicle,
                    such as the VIN and the taxable gross weight. Truckers need
                    Schedule 1 to register their vehicles with the state
                    authorities and to show compliance during roadside
                    inspections.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  3. Who is exempt from paying HUVT tax?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    Certain categories of vehicles are exempt from paying the
                    heavy highway use tax. However, even if a vehicle is exempt,
                    it is still essential to file HVUT tax form and claim the
                    exemption to avoid any potential penalties. Following are
                    some exemptions from paying HVUT:
                  </Typography>
                  <Typography component="div" itemProp="text">
                    <ul>
                      <li>
                        <b>Light Vehicles:</b> Vehicles with a gross weight of
                        less than 55,000 pounds.
                      </li>
                      <li>
                        <b>Agricultural Vehicles:</b> Vehicles used exclusively
                        for agricultural purposes and expected to travel less
                        than 7,500 miles during the tax period.
                      </li>
                      <li>
                        <b>Qualified Exempt Vehicles:</b> Some special-purpose
                        vehicles, such as bloodmobiles, mobile libraries, and
                        certain trucks used for tax-exempt purposes.
                      </li>
                      <li>
                        <b>Mileage Exemptions:</b> Vehicles that are expected to
                        be driven less than 5,000 miles during the tax period
                        (or 7,500 miles for agricultural vehicles).
                      </li>
                    </ul>
                  </Typography>
                </Box>
              </Box>

              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  4. Are there any penalties for missing the Form 2290 deadline?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    Yes, missing the Form 2290 filing deadline can result in
                    penalties. The penalty rates are as follows:
                  </Typography>
                  <Typography component="div" itemProp="text">
                    <TableContainer sx={{ border: '1px solid #828282', mt: 1 }}>
                      <Table sx={{}} aria-label="Due Date Chart">
                        <TableHead>
                          <TableRow
                            sx={{
                              backgroundColor: '#e8e8e8',
                            }}
                          >
                            <TableCell
                              sx={{
                                color: '#444',
                                width: 300,
                                borderBottom: '1px solid #828282',
                              }}
                            >
                              Failure to file the Heavy Vehicle Used Tax (HVUT)
                              return by the deadline.
                            </TableCell>

                            <TableCell
                              sx={{
                                color: '#444',
                                width: 300,
                                borderBottom: '1px solid #828282',
                              }}
                            >
                              Failure to file both the HVUT return and heavy
                              vehicle taxes
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow sx={{}}>
                            <TableCell>
                              4.5% of the total tax amount due, and the penalty
                              will increase monthly for up to five months.
                            </TableCell>
                            <TableCell>
                              0.5% of your total tax amount. You will also face
                              an additional interest charge of 0.54% per month.
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  5. How to track excise form status after submission?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    To track your return filing status,
                  </Typography>
                  <Typography component="div" itemProp="text">
                    <ul>
                      <li style={{ marginBottom: 8 }}>
                        <Link
                          href={`${process.env.NEXT_PUBLIC_APPLICATION_URL}signin/?ref=form2290`}
                          sx={{ color: '#0202ff' }}
                        >
                          {' '}
                          Sign In
                        </Link>{' '}
                        to your TaxZerone account.
                      </li>
                      <li style={{ marginBottom: 8 }}>
                        Navigate to the{' '}
                        <span style={{ fontWeight: 600 }}>
                          {' '}
                          Excise Tax Dashboard
                        </span>
                        .{' '}
                      </li>
                      <li style={{ marginBottom: 8 }}>
                        You'll be able to see whether your return has been
                        transmitted to the IRS, accepted, or rejected.{' '}
                      </li>
                    </ul>
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  6. Can I file Form 2290 electronically?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    Yes, you can file Form 2290 electronically with TaxZerone,
                    whether you have one vehicle or multiple vehicles. Enter
                    your vehicle and tax information, review your return, and
                    securely submit it to the IRS.
                  </Typography>
                </Box>
              </Box>
              <Box
                component="article"
                itemScope
                itemProp="mainEntity"
                itemType="https://schema.org/Question"
                sx={{
                  border: '1px solid rgba(145, 158, 171, 0.35)',
                  p: 2,
                  mb: 2,
                  backgroundColor: '#fff',
                }}
              >
                <Typography
                  variant="h3"
                  sx={{
                    fontWeight: 600,
                    color: '#36324a',
                    fontSize: { lg: 20, md: 18, sm: 18, xs: 18 },
                  }}
                  itemProp="name"
                >
                  7. Can I amend my Form 2290 after submission if I find an
                  error?
                </Typography>

                <Box
                  itemScope
                  itemProp="acceptedAnswer"
                  itemType="https://schema.org/Answer"
                >
                  <Typography variant="body1" itemProp="text">
                    Yes, if you find an error after submitting Form 2290, you
                    can file an amended return with TaxZerone to correct
                    eligible information, such as an incorrect taxable gross
                    weight or vehicle details.
                  </Typography>
                </Box>
              </Box>
            </Box>
            <Box sx={{ textAlign: 'center', mt: 3 }}>
              <Button
                variant="outlined"
                color="secondary"
                size="large"
                sx={{
                  borderWidth: 2,
                  borderRadius: 3,
                  textTransform: 'none',
                  '&:hover, &:focus, &:active': { borderWidth: 2 },
                }}
                href="/faqs/form-2290/"
              >
                More FAQs
              </Button>
            </Box>
          </Grid>
        </Grid>
        <Divider sx={{ mt: 2, mb: { xs: 2, sm: 0 } }} />
      </Container>
      <Grid
        component="section"
        container
        sx={{
          backgroundColor: '#f0f2f9',
          mx: '0 !important',
          width: '100% !important',
          py: { md: 8, sm: 4, xs: 2 },
        }}
        spacing={0}
        m={0}
      >
        <Container maxWidth="lg">
          <Grid
            container
            spacing={2}
            m={0}
            mt={0}
            className="MuiGrid-root-width"
          >
            <Grid
              size={{ xs: 12, md: 12 }}
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: {
                  lg: 'left',
                  md: 'left',
                  sm: 'center',
                  xs: 'center',
                },
              }}
            >
              <Typography
                variant="h2"
                sx={{
                  fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                  fontWeight: 600,
                  mb: 3,
                }}
              >
                Helpful Resources for Every Truckers
              </Typography>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-2290-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,

                    border: 'none',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    Form 2290 Instructions
                  </Typography>
                  <Typography variant="body1">
                    Follow our step-by-step guidance for completing your HVUT
                    return accurately.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-2290-due-dates/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,

                    border: 'none',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    HVUT Due Dates
                  </Typography>
                  <Typography variant="body1">
                    Stay informed about key filing deadlines and important tax
                    dates.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-2290-amendments/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,

                    border: 'none',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    HVUT Amendments
                  </Typography>
                  <Typography variant="body1">
                    Find out when updates are required and how to make
                    corrections.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-8849-schedule-6-instructions/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,

                    border: 'none',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    Form 8849
                  </Typography>
                  <Typography variant="body1">
                    Discover eligibility requirements and the refund claim
                    process.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/form-2290-schedule-1/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,

                    border: 'none',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    IRS Schedule 1
                  </Typography>
                  <Typography variant="body1">
                    Explore everything you need to know about obtaining and
                    using Schedule 1.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
            <Grid size={{ md: 4, sm: 6, xs: 12 }}>
              <Link
                href="/resources/excise-tax/hvut-form-2290-penalties/"
                sx={{ textDecoration: 'none' }}
              >
                <Paper
                  variant="outlined"
                  sx={{
                    px: 2.5,
                    py: 3,
                    borderRadius: 4,

                    border: 'none',
                    minWidth: '100%',
                    textAlign: 'center',
                    transition: 'all 0.3s ease 0s',
                    '&:hover': {
                      boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                      transform: 'scale(1.01)',
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    sx={{
                      fontWeight: 600,
                      fontSize: { md: 22, sm: 18, xs: 17 },
                      mb: 1,
                    }}
                  >
                    Penalties & Compliance
                  </Typography>
                  <Typography variant="body1">
                    Understand common penalties, interest charges, and ways to
                    avoid them.
                  </Typography>
                </Paper>
              </Link>
            </Grid>
          </Grid>
        </Container>
      </Grid>
      <Container
        maxWidth="lg"
        sx={{ mb: { xs: 3, sm: 5, md: 8 } }}
        component="section"
      >
        <Grid container spacing={2} m={0} pb={0} className="MuiGrid-root-width">
          <Grid size={12} textAlign="center">
            <Typography
              variant="h2"
              sx={{
                fontSize: { lg: 34, md: 30, sm: 26, xs: 22 },
                fontWeight: 600,
                mb: { xs: 0, sm: 3 },
                textAlign: 'center',
                lineHeight: 1.5,
                mt: 0,
              }}
            >
              Recent Blogs
            </Typography>
          </Grid>

          <BlogContentExcise />
        </Grid>
      </Container>
    </AppLayout>
  );
};

export default Form2290;
